













































































































































































































































































import { Component, Ref, Watch } from 'nuxt-property-decorator'
import { PageComponentVue } from '@/base'
import {
  UserDetailUserInfo,
  UserContentBasic,
  UserContentUsageSituation,
  UserContentOtherContacts,
  UserContentFamily,
  UserContentNewArrivalNotice,
  UserContentOldName,
  UserContentLending,
  UserContentReserved,
  UserContentMailHistory,
  UserContentBasicItem,
  defaultUserContentBasicItem,
  UserContentUsageSituationItem,
  defaultUserContentUsageSituationItem,
  UserContentOtherContactsItem,
  defaultUserContentOtherContactsItem,
  UserContentNewArrivalNoticeItem,
  defaultUserContentNewArrivalNoticeItem,
  UserContentOldNameItem,
  defaultUserContentOldNameItem,
  UserDetailUserInfoItem,
  defaultUserDetailUserInfoItem,
  UserContentFamilyItem,
  defaultUserContentFamilyItem,
  UserContentLendingItem,
  defaultUserContentLendingItem,
  UserContentReservedItem,
  defaultUserContentReservedItem,
  UserContentMailHistoryItem,
  defaultUserContentMailHistoryItem,
  UserExternalCollaborationItem,
  defaultUserExternalCollaborationItem,
  UserExternalCollaboration
} from '@/components/templates/user-detail'
import {
  UserMemoAndNote,
  UserMemoAndNoteItem,
  defaultUserMemoAndNoteItem
} from '@/components/organisms/UserMemoAndNote'
import { ModalUserIntegration } from '@/components/modals/ModalUserIntegration'
import { ModalUserCardReissue } from '@/components/modals/ModalUserCardReissue'
import {
  ModalReserve,
  ReserveBibliography
} from '@/components/modals/ModalReserve'
import {
  pageStore,
  appStore,
  userStore,
  alertStore,
  modalErrorStore,
  authUserStore,
  modalBibliographySearchStore,
  systemCodeStore,
  modalBibliographyDetailSetStore,
  modalBibliographyDetailRealStore,
  modalBibliographySearchResultStore,
  systemParameterStore,
  dataStore,
  reWriteCardStore,
  icTagStore
} from '@/store'
import {
  RECEIVED_CONNECT_PARAMETER,
  PAGE_LOADING_END,
  PAGE_LOADING_START,
  DATA_STORE_FETCHED
} from '@/config/event'
import {
  Alert,
  AlertMessage,
  bibliographyRealApi,
  BibliographyRealReserveSetGroup,
  BibliographySearchResultItem,
  defaultSystemCode,
  defaultUser,
  defaultUserAddress,
  ErrorMessage,
  Keyword,
  separateApi,
  SeparateKeyword,
  User,
  userApi
} from '@/api'
import { AlertFactory } from '@/factory'
import dayjs from 'dayjs'
import { ModalSimpleReserve } from '@/components/modals/ModalSimpleReserve'
import {
  AlertCodeAL300054,
  AlertCodeAL400015,
  AlertCodeAL400023,
  AlertCodeALC00002,
  AlertCodeCLT00009,
  AlertCodeCLT00012,
  AlertCodeCLT00013,
  AlertCodeCLT00023,
  AlertCodeCLT00033,
  AlertCodeCLT00034,
  AlertCodeCLT00050,
  AlertCodeICT,
  AlertCodeILC00023,
  AlertCodeINF00004,
  AlertCodeMKPF,
  AlertCodeRLC00009,
  AlertCodeRLC00010,
  AlertCodeTLC00003,
  AlertCodeWAR00001,
  AuthoritySearchType,
  BibliographyDetailRealTabType,
  BibliographyDetailSetTabType,
  BibliographyFullId,
  BibliographyFullIdWithMarcNo,
  defaultUserDetailStateInfo,
  IcTagReadingParameter,
  IcTagWriteIncompatible,
  IcTagWritingParameter,
  Prefix,
  UserDetailPageState,
  UserDetailStateInfo,
  UserDetailTabType,
  UserExternalCollaborationStatus,
  UserStatus
} from '@/types'
import { CODE_KEY } from '@/config'
import { SelectBibliographyDetailReal } from '@/store/ModalBibliographyDetailRealStore'
import { ModalSelectReserveType } from '@/components/modals/ModalSelectReserveType'
import { footerType } from '@/types/footer.type'
import { UserSearchConditionsItem } from '@/components/organisms/UserSearchCondition'
import { defaultUserPhoneTableItem } from '@/components/organisms/UserPhoneTable'
import { UserOldNameTableItem } from '@/components/organisms/UserOldNameTable'
import { defaultUserMailAddressTableItem } from '@/components/organisms/UserMailAddressTable'
import { setErrorMessage } from '@/utils/error'
import { SearchResultPagination } from '@/components/molecules/SearchResultPagination'
import {
  UserSearchTableItem,
  UserSearchTableItemData
} from '@/components/organisms/UserSearchTable'
import { defaultUserOtherContactsTableItem } from '@/components/organisms/UserOtherContactsTable'
import { isStrContainHiraganaOrKanji } from '@/utils'

export interface UserDetailItem {
  info: UserDetailUserInfoItem
  memoAndNote: UserMemoAndNoteItem
  basic: UserContentBasicItem
  usageSituation: UserContentUsageSituationItem
  otherContacts: UserContentOtherContactsItem
  family: UserContentFamilyItem
  newArrivalNotice: UserContentNewArrivalNoticeItem
  oldName: UserContentOldNameItem
  lending: UserContentLendingItem
  reserved: UserContentReservedItem
  mailHistory: UserContentMailHistoryItem
  externalCollaboration: UserExternalCollaborationItem
}

export const defaultUserDetailItem = (): UserDetailItem => ({
  info: defaultUserDetailUserInfoItem(),
  memoAndNote: defaultUserMemoAndNoteItem(),
  basic: defaultUserContentBasicItem(),
  usageSituation: defaultUserContentUsageSituationItem(),
  otherContacts: defaultUserContentOtherContactsItem(),
  family: defaultUserContentFamilyItem(),
  newArrivalNotice: defaultUserContentNewArrivalNoticeItem(),
  oldName: defaultUserContentOldNameItem(),
  lending: defaultUserContentLendingItem(),
  reserved: defaultUserContentReservedItem(),
  mailHistory: defaultUserContentMailHistoryItem(),
  externalCollaboration: defaultUserExternalCollaborationItem()
})

@Component({
  components: {
    UserExternalCollaboration,
    SearchResultPagination,
    ModalSelectReserveType,
    UserDetailUserInfo,
    UserContentBasic,
    UserContentUsageSituation,
    UserContentOtherContacts,
    UserContentFamily,
    UserContentNewArrivalNotice,
    UserContentOldName,
    UserContentLending,
    UserContentReserved,
    UserContentMailHistory,
    UserMemoAndNote,
    ModalUserIntegration,
    ModalUserCardReissue,
    ModalReserve,
    ModalSimpleReserve
  },
  beforeRouteEnter(to, from, next) {
    // 遷移が終了していない都合、データプロパティを更新していないので直接paramsを確認する
    const isCreate: boolean =
      to.params.id === 'create' || to.params.id === 'create-group'

    next(vm => {
      if ((vm as any).$webSocket.isFetchConnectParameter) {
        if (isCreate) {
          ;(vm as any).$reWriteCard.read()
        }
      } else {
        ;(vm as any).$eventBus.on(RECEIVED_CONNECT_PARAMETER, () => {
          ;(vm as any).setRightFooterActions()
          if (isCreate) {
            ;(vm as any).$reWriteCard.read()
          }
          // 初期表示の時に一回行えればそれでいいので、それ以後はイベント設定を解除とする
          ;(vm as any).$eventBus.off(RECEIVED_CONNECT_PARAMETER)
        })
      }

      systemCodeStore
        .fetchAllByCodeKeys([
          CODE_KEY.LIBRARY_BRANCH.KEY, // 貸出中資料テーブル
          CODE_KEY.USER_STATUS.KEY, // セレクトボックス、thenで使用
          CODE_KEY.USER_TYPE.KEY,
          CODE_KEY.GENDER.KEY, // セレクトボックス
          CODE_KEY.JAPANESE_CALENDAR_TYPE.KEY, // セレクトボックス、利用者の検索ダイアログで使用
          CODE_KEY.REMIND_EXCLUDE.KEY, // 督促抑止セレクトボックスで使用,
          CODE_KEY.USER_MAIL_CONTACT_TYPE.KEY, // 利用者メールアドレス連絡種別
          CODE_KEY.PROCESSING_PLACE.KEY,
          CODE_KEY.CLASSIFICATION.KEY // 貸出状況票レシート印刷用
        ])
        .then(() => {
          if (isCreate) {
            if ((vm as any).searchConditions.mailAddress.input !== '') {
              ;(vm as any).item.basic.mailAddresses = [
                Object.assign(defaultUserMailAddressTableItem(), {
                  address: {
                    input: (vm as any).searchConditions.mailAddress.input,
                    errorMessage: ''
                  },
                  reserve: systemCodeStore.defaultMailContactReserve,
                  newArrival: systemCodeStore.defaultMailContactNewArrival,
                  remind: systemCodeStore.defaultMailContactRemind,
                  notice: systemCodeStore.defaultMailContactNotice,
                  event: systemCodeStore.defaultMailContactEvent
                })
              ]
            }
            ;(vm as any).item.info.userStatus.input =
              systemCodeStore.findByCodeKeyAndCode(
                CODE_KEY.USER_STATUS.KEY,
                '1'
              ) ?? defaultSystemCode()
          }
        })
      systemParameterStore
        .fetchAllByCodeKeys([
          CODE_KEY.USER_OPAC_PASSWORD_SETTING.KEY, // opacパスワード非表示処理で使用
          CODE_KEY.NUMBER_MANAGEMENT.KEY,
          CODE_KEY.USER_REGISTRATION_UPDATE_REQUIRED_ITEM_SETTING.KEY,
          CODE_KEY.RESERVE_TYPE_SELECT_DISPLAY_ENABLED.KEY,
          CODE_KEY.RESERVE_CONTACT_METHOD_DEFAULT_VALUE_SETTING.KEY,
          CODE_KEY.FAMILY_MANAGEMENT_BASIC_NUMBER_SETTING.KEY,
          CODE_KEY.APPENDIX_LEND_MANAGEMENT_USING_ENABLED_SETTING.KEY,
          CODE_KEY.LEND_RETURN_MESSAGE_OUTPUT_SETTING.KEY,
          CODE_KEY.MAIL_HISTORY_SETTING.KEY,
          CODE_KEY.MOBILE_LIBRARY_PROCESSING_PLACE.KEY,
          CODE_KEY.LEND_OUT_TAB_DISPLAY_ITEM_SETTING.KEY
        ])
        .then(() => {
          if (isCreate) {
            ;(vm as any).item.basic.reserveNotice.input =
              systemParameterStore.reserveNoticeDefaultValue
          }
        })
      ;(vm as any).initialize()
    })
  },
  beforeRouteUpdate(to, from, next) {
    const isCreate =
      from.params.id === 'create' || from.params.id === 'create-group'
    const transitionPage = () => {
      if (isCreate && !(this as any).isUserUpdated) {
        if (reWriteCardStore.loaded) {
          this.$reWriteCard.eject({
            ejected: () => {
              next()
              ;(this as any).initialize()
            },
            unConnectedReaderWriter: () => {
              next()
              ;(this as any).initialize()
            }
          })
        } else {
          this.$reWriteCard.readCancel({
            readCanceled: () => {
              next()
              ;(this as any).initialize()
            },
            unConnectedReaderWriter: () => {
              next()
              ;(this as any).initialize()
            }
          })
        }
      } else if (isCreate && reWriteCardStore.readPending) {
        this.$reWriteCard.readCancel({
          readCanceled: () => {
            next()
            ;(this as any).initialize()
          },
          unConnectedReaderWriter: () => {
            next()
            ;(this as any).initialize()
          }
        })
      } else {
        next()
        ;(this as any).initialize()
      }

      ;(this as any).isUserUpdated = false
    }

    // 初期画面に戻る処理はTheNavBar.vueで対応しているので除外
    if (
      (this as any).state.isCreateOrUpdate() &&
      !(this as any).isUserUpdated
    ) {
      const alert: Alert = AlertFactory.create(AlertCodeALC00002)
      alertStore.setItem(alert)
      this.$modalAlert.open({
        onOkClick: transitionPage
      })
    } else {
      transitionPage()
    }
  },
  beforeRouteLeave(to, from, next) {
    // 初期画面に戻る処理はTheNavBar.vueで対応しているので除外
    const transitionPage = () => {
      if (
        reWriteCardStore.loaded &&
        ((this as any).state.isCreate() ||
          to.name !== 'lend' ||
          // eslint-disable-next-line camelcase
          (to.name === 'lend' && to.query?.user_id !== from.params.id))
      ) {
        this.$reWriteCard.eject({
          ejected: next,
          unConnectedReaderWriter: next
        })
      } else if (reWriteCardStore.readPending) {
        this.$reWriteCard.readCancel({
          readCanceled: next,
          unConnectedReaderWriter: next
        })
      } else {
        next()
      }
    }

    // TODO 直前のアラートデータを参照する処理は分かりづらい。後々対応を考える予定
    if (
      (this as any).state.isCreateOrUpdate() &&
      !(this as any).isUserUpdated &&
      alertStore.items[0]?.code !== AlertCodeCLT00009
    ) {
      const alert: Alert = AlertFactory.create(AlertCodeALC00002)
      alertStore.setItem(alert)
      this.$modalAlert.open({
        onOkClick: transitionPage
      })
    } else {
      ;(this as any).isUserUpdated = false
      transitionPage()
    }
  }
})
export default class UserDetailPage extends PageComponentVue {
  @Ref()
  modalUserIntegration!: ModalUserIntegration

  @Ref()
  modalUserCardReissue!: ModalUserCardReissue

  @Ref()
  modalReserve!: ModalReserve

  @Ref()
  modalSimpleReserve!: ModalSimpleReserve

  @Ref()
  modalSelectReserveType!: ModalSelectReserveType

  user: User = defaultUser()

  item: UserDetailItem = defaultUserDetailItem()

  state: UserDetailStateInfo = defaultUserDetailStateInfo()

  activeTab: UserDetailTabType = UserDetailTabType.Basic

  height: number = 0

  isUserUpdated: boolean = false

  observer: MutationObserver | undefined = undefined

  readReWriteCardByModal: boolean = false

  get processingIcTag(): boolean {
    return icTagStore.processing
  }

  get displayFamilyTab(): boolean {
    return (
      !this.state.isGroup() &&
      systemParameterStore.isManagementFamily &&
      (this.state.isShow() || !this.isManagementFamilyHomePhoneNumber)
    )
  }

  get displayLendingTab(): boolean {
    return this.state.isShow()
  }

  get displayReservedTab(): boolean {
    return this.state.isShow()
  }

  get displayMailHistoryTab(): boolean {
    return this.state.isShow() && this.isDisplayMailSendHistory
  }

  get isPagination(): boolean {
    return (
      userStore.isPagination &&
      this.$route.query?.pined !== 'true' &&
      this.state.isShow() &&
      this.searchResult.items.length > 1 &&
      this.currentPage !== 0
    )
  }

  get searchResult(): UserSearchTableItem {
    return userStore.searchResult
  }

  get currentPage(): number {
    return (
      this.searchResult
        .sortedItems()
        .findIndex(item => item.id === this.$route.params.id) + 1
    )
  }

  get isDisplayMailSendHistory(): boolean {
    return systemParameterStore.isDisplayMailSendHistory
  }

  get displayWorkType(): boolean {
    return dataStore.displayUserPageWorkType
  }

  get isManagementFamilyHomePhoneNumber(): boolean {
    return systemParameterStore.isManagementFamilyHomePhoneNumber
  }

  get tabType(): any {
    return UserDetailTabType
  }

  get existsUserId(): boolean {
    return this.$route.params.id !== '0'
  }

  get isUserStatusEnabled(): boolean {
    return this.user.base.status.code === UserStatus.Enabled
  }

  get isUserDelete(): boolean {
    return this.item.info.userStatus.input.code === UserStatus.Deleted
  }

  get searchConditions(): UserSearchConditionsItem {
    return userStore.searchConditions
  }

  get tabStyles(): object {
    if (appStore._fontSizeType === 'normal') {
      return {}
    }

    return {
      'font-size': appStore._fontSizeNormal + 'px'
    }
  }

  get lendingBadgeColor(): string {
    return this.user.lendCollections.length > 0 ? 'green' : 'grey'
  }

  get reservedBadgeColor(): string {
    if (this.user.reserveCollections.length === 0) {
      return 'grey'
    }

    let badgeColor: string = ''

    for (const collection of this.user.reserveCollections) {
      switch (collection.reserveStatusMessage) {
        case '受取待':
          if (
            collection.reserveExpiration !== '' &&
            collection.reserveExpiration < dayjs().format('YYYYMMDD')
          ) {
            return 'red'
          } else {
            badgeColor = 'yellow accent-4'
          }
          break
        case '準備中':
          if (badgeColor !== 'yellow accent-4') {
            badgeColor = '#99D9EA'
          }
          break
        case '回送中':
          if (badgeColor !== 'yellow accent-4' && badgeColor !== '#99D9EA') {
            badgeColor = 'orange'
          }
          break
        case '返却待':
          if (badgeColor === '') {
            badgeColor = 'green'
          }
      }
    }

    return badgeColor !== '' ? badgeColor : 'green'
  }

  get isHitOneSearchResults(): boolean {
    return modalBibliographySearchStore.total === 1
  }

  get searchResults(): BibliographySearchResultItem[] {
    return modalBibliographySearchStore.items
  }

  get isAuthUserGroupUserOnlyReference(): boolean {
    return authUserStore.isAuthUserGroupUserOnlyReference
  }

  get enabledIcTag(): boolean {
    return dataStore.enabledIcTag
  }

  get processingReWriteCard(): boolean {
    return reWriteCardStore.processing
  }

  get loadedReWriteCard(): boolean {
    return reWriteCardStore.loaded
  }

  get displayOtherContactTab(): boolean {
    return dataStore.displayUserPageOtherContactTab
  }

  get displayNewArrivalNoticeTab(): boolean {
    return dataStore.displayUserPageNewArrivalNoticeTab
  }

  get displayOldNameTab(): boolean {
    return dataStore.displayUserPageOldNameTab
  }

  get displayExternalCollaborationTab(): boolean {
    return dataStore.displayUserPageExternalCollaborationTab
  }

  @Watch('processingReWriteCard')
  onToggleProcessingReWriteCard(): void {
    this.setRightFooterActions()
  }

  @Watch('loadedReWriteCard')
  onToggleLoadedReWriteCard(): void {
    this.setRightFooterActions()
  }

  @Watch('searchResult.items')
  onSearchUsers(): void {
    this.changeTab(UserDetailTabType.Basic)
  }

  @Watch('processingIcTag')
  onToggleProcessingIcTag(): void {
    this.setRightFooterActions()
  }

  // ページネーションがある場合、編集画面切替でうまく取得ができないのでnextTickを設定する
  @Watch('isPagination')
  onChangeIsPagination(): void {
    this.$nextTick(this.calculateTableHeight)
  }

  @Watch('activeTab')
  onChangeTab(): void {
    this.calculateTableHeight()
  }

  fetch() {
    // ナビゲーションガードではタイミング的にdataStore取得処理よりも早いのでイベントバスで対応
    this.$eventBus.on(RECEIVED_CONNECT_PARAMETER, () => {
      this.setRightFooterActions()

      // 初期表示の時に一回行えればそれでいいので、それ以後はイベント設定を解除とする
      this.$eventBus.off(RECEIVED_CONNECT_PARAMETER)
    })
  }

  created() {
    this.$eventBus.on(DATA_STORE_FETCHED, () =>
      this.$nextTick(this.setRightFooterActions)
    )
  }

  activated(): void {
    this.calculateTableHeight()
    window.addEventListener('resize', this.calculateTableHeight)

    // HACK 遷移前ページで閉じかけたDOM要素に反応してしまうのでMutationObserverの開始を少し送らせて対応を取る
    setTimeout(this.connectMutationObserver, 500)
  }

  deactivated(): void {
    window.removeEventListener('resize', this.calculateTableHeight)
    this.$eventBus.off(DATA_STORE_FETCHED)

    this.disconnectMutationObserver()
  }

  connectMutationObserver(): void {
    // 例外はあるが、ダイアログの開閉検知はここで管理する事にしたい
    // DOMクラスの変更自体を監視することは不可能だったので、追加と削除をしているオーバーレイを対象としている（ダイアログの表示数も条件に含めているので問題は無いはず）
    this.observer = new MutationObserver(mutations => {
      const modals: any[] = Array.from(
        document.querySelectorAll<HTMLElement>('.v-dialog__content--active')
      )

      if (!reWriteCardStore.power) {
        this.readReWriteCardByModal = false

        mutations.forEach(mutation => {
          if (
            Array.from(mutation.addedNodes).some(
              (node: any) =>
                node.tagName && node.classList.contains('v-overlay')
            )
          ) {
            if (modals.length === 1) {
              // 一応子孫ノードのidを調べれば目的のダイアログを探せるがネストが深くなるので分かりづらい
              // ダイアログのタイトルさえ重複しなければこちらで問題ないので下記で処理をする
              if (
                modals.some((modal: any) =>
                  modal.textContent.includes('カード再発行')
                )
              ) {
                this.$reWriteCard.read({
                  readCompleted: () => (this.readReWriteCardByModal = true)
                })
              }
            }
          }
        })

        return
      }

      mutations.forEach(mutation => {
        if (
          Array.from(mutation.addedNodes).some(
            (node: any) => node.tagName && node.classList.contains('v-overlay')
          )
        ) {
          if (modals.length > 1) {
            this.$reWriteCard.readCancel()
          } else if (modals.length === 1) {
            // 一応子孫ノードのidを調べれば目的のダイアログを探せるがネストが深くなるので分かりづらい
            // ダイアログのタイトルさえ重複しなければこちらで問題ないので下記で処理をする
            if (
              modals.some((modal: any) =>
                modal.textContent.includes('カード再発行')
              ) &&
              !reWriteCardStore.loaded
            ) {
              this.$reWriteCard.read({
                readCompleted: () => (this.readReWriteCardByModal = true)
              })
            }
          }
        }
        if (
          Array.from(mutation.removedNodes).some(
            (node: any) => node.tagName && node.classList.contains('v-overlay')
          )
        ) {
          if (modals.length === 1) {
            // 一応子孫ノードのidを調べれば目的のダイアログを探せるがネストが深くなるので分かりづらい
            // ダイアログのタイトルさえ重複しなければこちらで問題ないので下記で処理をする
            if (
              modals.some((modal: any) =>
                modal.textContent.includes('カード再発行')
              ) &&
              !reWriteCardStore.loaded
            ) {
              this.$reWriteCard.read({
                readCompleted: () => (this.readReWriteCardByModal = true)
              })
            }
          }
        }
      })
    })
    // appは確実に存在する
    this.observer.observe(document.getElementById('app') as HTMLElement, {
      childList: true,
      attributeFilter: ['class']
    })
  }

  disconnectMutationObserver(): void {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  calculateTableHeight(): void {
    this.height = 0
    this.$nextTick(() => {
      const pageCollection: HTMLCollection | null = document.getElementsByClassName(
        'v-main__wrap'
      ) as HTMLCollectionOf<HTMLElement>

      if (
        pageCollection[0]?.children.length > 0 &&
        pageCollection[0]?.children[0]?.children.length > 1 &&
        pageCollection[0]?.children[0]?.children[1]?.children.length > 0
      ) {
        const deductHeight: number =
          window.innerHeight - pageCollection[0]?.clientHeight

        this.height =
          window.innerHeight -
          deductHeight -
          pageCollection[0].children[0].children[1].children[0].clientHeight -
          1

        if (
          (this.activeTab === this.tabType.NewArrivalNotice &&
            this.state.isCreateOrUpdate()) ||
          this.activeTab === this.tabType.OldName
        ) {
          this.height /= 2
        } else if (this.activeTab === this.tabType.NewArrivalNotice) {
          this.height /= 3
        }
      }
    })
  }

  onUpdatedExpirationDate(): void {
    const initVal: UserContentUsageSituationItem = defaultUserContentUsageSituationItem()
    this.item.usageSituation.cardLostCount.input = initVal.cardLostCount.input
    this.item.usageSituation.cardLostDate.input = initVal.cardLostDate.input
  }

  alertOldId(): void {
    if (
      userStore.displayOldIdAlert &&
      userStore.searchedConditions.id.input !== '' &&
      userStore.searchedConditions.id.input === this.user.base.cardLost.uno
    ) {
      alertStore.setItem(
        AlertFactory.create(
          AlertCodeWAR00001,
          `旧カード番号：${this.user.base.cardLost.uno}`,
          '再発行済み'
        )
      )
      this.$modalAlert.open({
        modalType: 'INFO'
      })

      userStore.setDisplayOldIdAlert(false)
    }
  }

  setInitialActiveTab(): void {
    if (this.state.isCreate()) {
      this.changeTab(UserDetailTabType.Basic)
      return
    }

    const initializeActiveTab = () => this.changeTab(UserDetailTabType.Basic)

    switch (this.activeTab) {
      case UserDetailTabType.Family:
        if (!this.displayFamilyTab) {
          initializeActiveTab()
        }
        break
      case UserDetailTabType.Lending:
        if (!this.displayLendingTab) {
          initializeActiveTab()
        }
        break
      case UserDetailTabType.Reserved:
        if (!this.displayReservedTab) {
          initializeActiveTab()
        }
        break
      case UserDetailTabType.MailHistory:
        if (!this.displayMailHistoryTab) {
          initializeActiveTab()
        }
        break
    }
  }

  setTitleAndFooterActions(): void {
    if (this.state.isUserCreateOrUpdate()) {
      pageStore.setTitle('利用者の管理：更新')
    }

    if (this.state.isGroupCreateOrUpdate()) {
      pageStore.setTitle('利用者の管理：更新（団体）')
    }

    if (this.state.isUserShow()) {
      pageStore.setTitle('利用者の管理：照会')
    }

    if (this.state.isGroupShow()) {
      pageStore.setTitle('利用者の管理：照会（団体）')
    }

    this.setLeftFooterActions()
    this.setRightFooterActions()
  }

  setLeftFooterActions(): void {
    pageStore.setLeftFooterActions(
      this.state.isCreateOrUpdate()
        ? [
            {
              text: 'キャンセル',
              icon: '',
              callback: () => {
                if (this.state.isCreate()) {
                  this.goUserListPage()
                  return
                }

                this.goUserDetailPage()
              }
            }
          ]
        : [
            {
              text: 'トップへ',
              icon: 'arrow-left',
              callback: () => {
                this.$router.push('/')
              }
            },
            {
              text: '検索結果一覧へ',
              icon: '',
              callback: () => {
                userStore.resetOpenedNavigationItem()
                this.goUserListPage()
              }
            }
          ]
    )
  }

  setRightFooterActions(): void {
    // 挙動が重くなった為、他ページに遷移した後メソッドを実行する事が増えだしたのでページ内でのみ処理を行うように修正
    if (this.$route.name !== 'user-id') {
      return
    }

    if (this.state.isCreateOrUpdate()) {
      const rightFooterActions: footerType.IAction[] = [
        {
          text: '登録',
          icon: '',
          callback: () => {
            if (this.state.isUpdate() && this.isUserDelete) {
              alertStore.setItem(AlertFactory.create(AlertCodeAL400015))
              this.$modalAlert.open({
                onOkClick: this.userDelete
              })
              return
            }

            if (this.state.isUserCreate()) {
              if (!this.$webSocket.reWriteCardEnabled) {
                this.userCreate()
                return
              }

              if (reWriteCardStore.registered) {
                alertStore.setItem(AlertFactory.create(AlertCodeCLT00033))
                this.$modalAlert.open({
                  onOkClick: this.userCreate
                })
                return
              }

              if (!reWriteCardStore.loaded) {
                alertStore.setItem(AlertFactory.create(AlertCodeCLT00034))
                this.$modalAlert.open({
                  onOkClick: this.userCreate
                })

                return
              }

              this.userCreate()
              return
            }

            if (this.state.isUserUpdate()) {
              this.userUpdate()
              return
            }

            if (this.state.isGroupCreate()) {
              if (!this.$webSocket.reWriteCardEnabled) {
                this.groupCreate()
                return
              }

              if (reWriteCardStore.registered) {
                alertStore.setItem(AlertFactory.create(AlertCodeCLT00033))
                this.$modalAlert.open({
                  onOkClick: this.groupCreate
                })
                return
              }

              if (!reWriteCardStore.loaded) {
                alertStore.setItem(AlertFactory.create(AlertCodeCLT00034))
                this.$modalAlert.open({
                  onOkClick: this.groupCreate
                })

                return
              }

              this.groupCreate()
              return
            }

            if (this.state.isGroupUpdate()) {
              this.groupUpdate()
            }
          }
        },
        {
          text: 'カナ振り',
          icon: '',
          callback: async () => {
            await this.separateName()
            if (this.activeTab === this.tabType.OtherContacts) {
              await this.separateGuardianName()
            }
            if (this.activeTab === this.tabType.OldName) {
              await this.separateOldName()
            }
          }
        },
        {
          text: '他の利用者から複写',
          icon: '',
          callback: () => {
            this.$modalUserSearch.open({
              onClickOk: (userId: string) => {
                this.copyOtherUserInfo(userId)
              },
              onClickCancel: (updatedUserIds: string[]) => {
                if (updatedUserIds.some(id => id === this.$route.params.id)) {
                  this.initialize()
                }
              }
            })
          }
        }
      ]

      if (this.enabledIcTag) {
        rightFooterActions.unshift({
          text: 'ＩＣ書込',
          icon: '',
          disabled: this.processingIcTag,
          callback: this.icWriting
        })
      }

      pageStore.setRightFooterActions(rightFooterActions)
      return
    }

    const rightFooterActions: footerType.IAction[] = [
      {
        text: 'カード再発行',
        icon: '',
        callback: () => {
          this.modalUserCardReissue.open({
            userId: this.user.base.id,
            onUpdated: (newUserId: string) => {
              if (reWriteCardStore.loaded) {
                this.$reWriteCard.register({
                  parameter: {
                    userNo: newUserId,
                    branchName: this.user.base.branchCode.name,
                    collections: this.user.lendCollections.map(
                      lendCollection => ({
                        title: lendCollection.displayTitle,
                        dueDate: `${lendCollection.dueDate.substr(
                          0,
                          4
                        )}-${lendCollection.dueDate.substr(
                          4,
                          2
                        )}-${lendCollection.dueDate.substr(6, 2)}`
                      })
                    )
                  },
                  isEject: false,
                  registered: () => {
                    this.readReWriteCardByModal = false
                    this.$reWriteCard.readCancel()
                    this.$router.push(`/user/${newUserId}`)
                  },
                  unConnectedReaderWriter: () => {
                    this.readReWriteCardByModal = false
                    this.$reWriteCard.readCancel()
                    this.$router.push(`/user/${newUserId}`)
                  }
                })
              } else {
                this.$reWriteCard.readCancel()
                this.$router.push(`/user/${newUserId}`)
              }
            },
            onCanceled: () => {
              if (this.readReWriteCardByModal) {
                this.$reWriteCard.eject()
              } else {
                this.$reWriteCard.readCancel()
              }

              this.readReWriteCardByModal = false
            }
          })
        },
        disabled: !this.existsUserId || this.isAuthUserGroupUserOnlyReference
      },
      {
        text: '利用者の統合',
        icon: '',
        callback: () => {
          this.modalUserIntegration.open({
            id: this.user.base.id,
            isGroup: this.state.isGroup(),
            userType: this.user.base.userType,
            branchCode: this.user.base.branchCode,
            userStatus: this.user.base.status,
            name: this.state.isGroup()
              ? this.user.group.name
              : this.user.personal.name,
            expirationDate: this.user.base.expirationDate,
            birthday: this.user.personal.birthday,
            nameKana: this.state.isGroup()
              ? this.user.group.nameKana
              : this.user.personal.nameKana,
            gender: this.user.personal.gender,
            userAddress: this.state.isGroup()
              ? this.user.group.userAddress
              : this.user.personal.userAddress,
            phones: this.state.isGroup()
              ? this.user.group.phones
              : this.user.personal.phones,
            mailAddresses: this.state.isGroup()
              ? this.user.group.mailAddresses
              : this.user.personal.mailAddresses,
            onUpdated: this.initialize
          })
        },
        disabled: !this.existsUserId || this.isAuthUserGroupUserOnlyReference
      },
      {
        text: '予約',
        icon: '',
        callback: this.openModalBibliographySearchCondition,
        disabled: !this.isUserStatusEnabled || !this.existsUserId
      },
      {
        text: 'クリア',
        icon: '',
        callback: () => {
          userStore.resetOpenedNavigationItem()
          this.$router.push(`/user/0`)
        },
        disabled: !this.existsUserId
      },
      {
        text: '貸出',
        icon: '',
        callback: () => {
          this.$router.push(`/lend?user_id=${this.user.base.id}`)
        },
        disabled: !this.isUserStatusEnabled || !this.existsUserId
      }
    ]

    if (dataStore.enabledMyNumberCard) {
      if (this.user.base.ppid === '') {
        rightFooterActions.unshift({
          text: 'マイナンバーカード登録',
          icon: '',
          callback: () => {
            const width = 1000
            const height = 1300
            const left = (screen.width - width) / 2
            const top = (screen.height - height) / 2

            this.$eventBus.emit(PAGE_LOADING_START)

            const ppid = document.getElementById(
              'ppid_result'
            ) as HTMLInputElement
            const userId = document.getElementById(
              'user_id_result'
            ) as HTMLInputElement
            const differentName = document.getElementById(
              'different_name'
            ) as HTMLInputElement
            const confirm = document.getElementById(
              'confirm_result'
            ) as HTMLInputElement

            ppid.value = ''
            userId.value = ''
            differentName.value = ''
            confirm.value = ''

            const openWindow = window.open(
              `/api/mkpf-agreement?regist_user_id=${this.user.base.id}`,
              'sub',
              `width=${width}, height=${height}, left=${left}, top=${top}`
            )

            const interval = setInterval(() => {
              if (!openWindow || openWindow.closed) {
                clearInterval(interval)

                const differentName = document.getElementById(
                  'different_name'
                ) as HTMLInputElement
                console.log('differentName.value', differentName.value)
                if (differentName.value === '1') {
                  this.$eventBus.emit(PAGE_LOADING_END)
                  this.showDifferentNameAlert()
                  return
                }
                // イベントバス「PAGE_LOADING_END」はこのメソッドで必ず行われるので問題ない
                this.initialize()
              }
            }, 1000)
          },
          disabled: !this.existsUserId
        })
      } else {
        rightFooterActions.unshift({
          text: 'マイナンバーカード解除',
          icon: '',
          callback: () => {
            alertStore.setItem(
              AlertFactory.create(
                AlertCodeCLT00050,
                'マイナンバーカードと利用者情報の紐付け解除'
              )
            )
            this.$modalAlert.open({
              onOkClick: this.releaseUserMyNumberCard
            })
          },
          disabled: !this.existsUserId
        })
      }
    }

    if (dataStore.enabledFelica) {
      if (this.user.base.felicaId === '') {
        rightFooterActions.unshift({
          text: 'FeliCaカード登録',
          icon: '',
          callback: () => {
            alertStore.setItem(
              AlertFactory.create(
                AlertCodeCLT00050,
                'FeliCaカードと利用者情報の紐付け'
              )
            )
            this.$modalAlert.open({
              onOkClick: () =>
                this.$felica.update({
                  parameter: { userId: this.user.base.id },
                  updated: this.initialize
                })
            })
          },
          disabled: !this.existsUserId
        })
      } else {
        rightFooterActions.unshift({
          text: 'FeliCaカード解除',
          icon: '',
          callback: () => {
            alertStore.setItem(
              AlertFactory.create(
                AlertCodeCLT00050,
                'FeliCaカードと利用者情報の紐付け解除'
              )
            )
            this.$modalAlert.open({
              onOkClick: this.releaseUserFelicaId
            })
          },
          disabled: !this.existsUserId
        })
      }
    }

    rightFooterActions.unshift(
      {
        text: '編集',
        icon: '',
        callback: () => {
          this.$router.push({
            path: `/user/${this.user.base.id}`,
            query: {
              title: this.item.info.name.input,
              page: 'edit',
              pined: this.$route.query?.pined
            }
          })
        },
        disabled: !this.existsUserId || this.isAuthUserGroupUserOnlyReference
      },
      {
        text: '簡易予約',
        icon: '',
        callback: () => {
          this.modalSimpleReserve.open({
            id: this.user.base.id,
            info: this.item.info,
            contactMethod: this.user.base.reserveNotice,
            onUpdated: this.initialize
          })
        },
        disabled: !this.isUserStatusEnabled || !this.existsUserId
      }
    )

    // 算出プロパティがうまく動作してくれない為、下記のとおりに設定
    if (dataStore.enabledReWriteCard && this.$webSocket.reWriteCardEnabled) {
      rightFooterActions.unshift(
        {
          text: 'リライト登録',
          icon: '',
          disabled: !this.existsUserId || reWriteCardStore.processing,
          callback: () => {
            const register = () => {
              const registerProcess = () =>
                this.$reWriteCard.register({
                  parameter: {
                    userNo: this.user.base.id,
                    branchName: this.user.base.branchCode.name,
                    collections: this.user.lendCollections.map(
                      lendCollection => ({
                        title: lendCollection.displayTitle,
                        dueDate: `${lendCollection.dueDate.substr(
                          0,
                          4
                        )}-${lendCollection.dueDate.substr(
                          4,
                          2
                        )}-${lendCollection.dueDate.substr(6, 2)}`
                      })
                    )
                  },
                  isEject: true,
                  registered: () => {
                    if (this.readReWriteCardByModal) {
                      this.$reWriteCard.eject()
                    } else {
                      this.$reWriteCard.readCancel()
                    }

                    this.readReWriteCardByModal = false
                  },
                  unConnectedReaderWriter: () =>
                    (this.readReWriteCardByModal = false)
                })

              if (reWriteCardStore.registered) {
                alertStore.setItem(AlertFactory.create(AlertCodeCLT00033))
                this.$nextTick(() =>
                  setTimeout(
                    () =>
                      this.$modalAlert.open({
                        onOkClick: registerProcess,
                        onCancelClick: () => {
                          if (this.readReWriteCardByModal) {
                            this.$reWriteCard.eject()
                          } else {
                            this.$reWriteCard.readCancel()
                          }

                          this.readReWriteCardByModal = false
                        }
                      }),
                    100
                  )
                )
                return
              }

              registerProcess()
            }

            if (reWriteCardStore.loaded) {
              register()
            } else {
              this.$reWriteCard.read({
                readed: () => {
                  alertStore.setItem(
                    AlertFactory.create(AlertCodeINF00004, '利用者情報', '登録')
                  )
                  this.$modalAlert.open({
                    onOkClick: () => {
                      if (reWriteCardStore.loaded) {
                        register()
                      } else {
                        this.$reWriteCard.readCancel()
                        this.$nextTick(() =>
                          setTimeout(() => {
                            // ここはクライアントサービス側からアラートが出るようにはなっているのだが…どうしようかな
                            alertStore.setItem(
                              AlertFactory.create(
                                AlertCodeTLC00003,
                                'リライトカードが未挿入',
                                '登録'
                              )
                            )
                            this.$modalAlert.open({
                              onOkClick: () => {
                                if (this.readReWriteCardByModal) {
                                  this.$reWriteCard.eject()
                                } else {
                                  this.$reWriteCard.readCancel()
                                }

                                this.readReWriteCardByModal = false
                              }
                            })
                          }, 100)
                        )
                      }
                    }
                  })
                },
                readCompleted: () => (this.readReWriteCardByModal = true)
              })
            }
          }
        },
        {
          text: '印字',
          icon: '',
          disabled: !this.existsUserId || reWriteCardStore.processing,
          callback: () => {
            const write = () => {
              if (reWriteCardStore.registered) {
                this.$reWriteCard.write({
                  parameter: {
                    userNo: this.user.base.id,
                    branchName: this.user.base.branchCode.name,
                    collections: this.user.lendCollections.map(
                      lendCollection => ({
                        title: lendCollection.displayTitle,
                        dueDate: `${lendCollection.dueDate.substr(
                          0,
                          4
                        )}-${lendCollection.dueDate.substr(
                          4,
                          2
                        )}-${lendCollection.dueDate.substr(6, 2)}`
                      })
                    )
                  },
                  wrote: () => {
                    this.$reWriteCard.readCancel()
                    this.readReWriteCardByModal = false
                  },
                  unConnectedReaderWriter: () =>
                    (this.readReWriteCardByModal = false),
                  notProcessed: () => {
                    if (this.readReWriteCardByModal) {
                      this.$reWriteCard.eject()
                    } else {
                      this.$reWriteCard.readCancel()
                    }
                    this.readReWriteCardByModal = false
                  }
                })
              } else {
                this.$reWriteCard.register({
                  parameter: {
                    userNo: this.user.base.id,
                    branchName: this.user.base.branchCode.name,
                    collections: this.user.lendCollections.map(
                      lendCollection => ({
                        title: lendCollection.displayTitle,
                        dueDate: `${lendCollection.dueDate.substr(
                          0,
                          4
                        )}-${lendCollection.dueDate.substr(
                          4,
                          2
                        )}-${lendCollection.dueDate.substr(6, 2)}`
                      })
                    )
                  },
                  isEject: true,
                  registered: () => {
                    this.$reWriteCard.readCancel()

                    this.readReWriteCardByModal = false
                  },
                  unConnectedReaderWriter: () =>
                    (this.readReWriteCardByModal = false)
                })
              }
            }

            if (reWriteCardStore.loaded) {
              write()
            } else {
              this.$reWriteCard.read({
                readed: () => {
                  alertStore.setItem(
                    AlertFactory.create(AlertCodeINF00004, '貸出情報', '印字')
                  )
                  this.$modalAlert.open({
                    onOkClick: () => {
                      this.$nextTick(() =>
                        setTimeout(() => {
                          if (reWriteCardStore.loaded) {
                            write()
                          } else {
                            this.$reWriteCard.readCancel()
                            alertStore.setItem(
                              AlertFactory.create(
                                AlertCodeTLC00003,
                                'リライトカードが未挿入',
                                '印字'
                              )
                            )
                            this.$modalAlert.open()
                          }
                        }, 100)
                      )
                    }
                  })
                },
                readCompleted: () => (this.readReWriteCardByModal = true)
              })
            }
          }
        },
        {
          text: '排出',
          icon: '',
          disabled: reWriteCardStore.processing || !reWriteCardStore.loaded,
          callback: this.$reWriteCard.eject
        }
      )
    }

    pageStore.setRightFooterActions(rightFooterActions)
  }

  changeTab(tabType: UserDetailTabType): void {
    this.activeTab = tabType
  }

  icWriting(): void {
    icTagStore.startProcess()

    // コードの共通化、削減の為に定数としている。それ以外の意図はない
    const initialize = () => {
      icTagStore.endProcess()
    }

    const sendICTagWriting = async () => {
      let goPageFunction: Function

      const icTagWritingFunction = () => {
        this.$webSocket.sendICTagWriting(
          {
            industryCode: dataStore.industryCode,
            branchType: dataStore.branchType,
            agencyCode: dataStore.agencyCode,
            noFlag: '1',
            no: this.state.isCreate()
              ? this.item.info.userId.input
              : this.user.base.id
          },
          (isConnect: boolean, parameter?: IcTagWritingParameter) => {
            const onWrote = () => {
              initialize()
              goPageFunction()
            }

            if (!isConnect || !parameter) {
              onWrote()
              return
            }

            if (parameter.code === IcTagWriteIncompatible) {
              alertStore.setItem({
                code: AlertCodeICT,
                level: 'ERROR',
                message: '書込みに対応していないＩＣタグが置かれています。',
                attribute: '',
                index: 0,
                subAttribute: ''
              })
              this.$modalAlert.open({
                onOkClick: onWrote
              })
              return
            }

            if (!parameter.result) {
              alertStore.setItem(
                AlertFactory.create(AlertCodeCLT00012, 'ICタグ')
              )
              this.$modalAlert.open({
                onOkClick: onWrote
              })
              return
            }

            alertStore.setItem(AlertFactory.create(AlertCodeCLT00013))
            this.$modalAlert.open({
              onOkClick: onWrote
            })
          }
        )
      }

      try {
        if (this.state.isUpdate() && this.isUserDelete) {
          alertStore.setItem(AlertFactory.create(AlertCodeAL400015))
          // これを表示する直前にアラートを閉じる動作をしているので表示が出来なくなる、その為タイミングを少し遅らせている
          this.$nextTick(() => {
            setTimeout(() => {
              this.$modalAlert.open({
                onOkClick: async () => {
                  try {
                    await this.userDelete()
                    goPageFunction = this.goUserListPage
                    icTagWritingFunction()
                  } catch {
                    initialize()
                  }
                },
                onCancelClick: initialize
              })
            })
          })
          return
        }

        if (this.state.isUserCreate()) {
          // ここだけはuserCreate内のcatchで処理をしたかったのでコールバックを渡す
          await this.userCreate(false, () => {
            goPageFunction = this.goUserDetailPage
            icTagWritingFunction()
          })
        } else if (this.state.isUserUpdate()) {
          await this.userUpdate()
        } else if (this.state.isGroupCreate()) {
          await this.groupCreate()
        } else if (this.state.isGroupUpdate()) {
          await this.groupUpdate()
        }

        if (!this.state.isUserCreate()) {
          goPageFunction = this.goUserDetailPage
          icTagWritingFunction()
        }
      } catch (error) {
        initialize()
      }
    }

    this.$webSocket.sendICTagReading(
      '',
      (isConnect: boolean, parameter?: IcTagReadingParameter) => {
        if (!isConnect || !parameter) {
          initialize()
          return
        }

        if (!parameter.result) {
          alertStore.setItem(AlertFactory.create(AlertCodeCLT00023))
          this.$modalAlert.open({
            onOkClick: initialize
          })
          return
        }

        if (parameter.data.length === 0) {
          alertStore.setItem(AlertFactory.create(AlertCodeRLC00010))
          this.$modalAlert.open({
            onOkClick: initialize
          })
          return
        }

        // 複数タグに限り、リーダで読み込んだ全てのタグをチェックする
        if (parameter.data.length > 1) {
          alertStore.setItem(AlertFactory.create(AlertCodeRLC00009))
          this.$modalAlert.open({
            onOkClick: initialize
          })
          return
        }

        if (parameter.data.some(value => value.oldTag === '1')) {
          alertStore.setItem({
            code: AlertCodeICT,
            level: 'ERROR',
            message: '書込みに対応していないＩＣタグが置かれています。',
            attribute: '',
            index: 0,
            subAttribute: ''
          })
          this.$modalAlert.open({
            onOkClick: initialize
          })
          return
        }

        if (parameter.data[0].no !== '0'.repeat(parameter.data[0].no.length)) {
          alertStore.setItem({
            code: AlertCodeAL300054,
            level: 'WARN',
            message: `タグは既に\n業界コード：${parameter.data[0].industryCode}\n館種別：${parameter.data[0].branchType}\n機関コード：${parameter.data[0].agencyCode}\n利用者番号：${parameter.data[0].no}\nが登録されています。\n利用者情報を上書きしますか。`,
            attribute: '',
            index: 0,
            subAttribute: ''
          })
          this.$modalAlert.open({
            onOkClick: sendICTagWriting,
            onCancelClick: initialize
          })
          return
        }

        sendICTagWriting()
      }
    )
  }

  async fetchUser() {
    try {
      this.user = await userApi.getUser({
        id: this.$route.params.id
      })

      if (this.$route?.query.page === 'edit') {
        if (this.user.group.name !== '') {
          this.state.state = UserDetailPageState.GroupUpdate
        } else {
          this.state.state = UserDetailPageState.UserUpdate
        }
      }

      if (this.$route?.query.page !== 'edit') {
        if (this.user.group.name !== '') {
          this.state.state = UserDetailPageState.GroupShow
        } else {
          this.state.state = UserDetailPageState.UserShow
        }
      }

      this.item = {
        info: {
          userId: {
            input: this.user.base.id,
            errorMessage: ''
          },
          userType: {
            input: this.user.base.userType.code,
            display: this.user.base.userType.shortName,
            errorMessage: ''
          },
          workType: this.user.personal.workType,
          name: {
            input: this.state.isGroup()
              ? this.user.group.name
              : this.user.personal.name,
            errorMessage: ''
          },
          expirationDate: {
            input: this.user.base.expirationDate,
            errorMessage: ''
          },
          nameKana: {
            input: this.state.isGroup()
              ? this.user.group.nameKana
              : this.user.personal.nameKana,
            errorMessage: ''
          },
          userStatus: {
            input: this.user.base.status,
            errorMessage: ''
          },
          studentGrade: {
            input: this.user.personal.studentGrade.code,
            display: this.user.personal.studentGrade.shortName,
            errorMessage: ''
          },
          studentClass: {
            input: this.user.personal.studentClass.code,
            display: this.user.personal.studentClass.shortName,
            errorMessage: ''
          },
          studentNumber: {
            input: this.user.personal.studentNumber,
            errorMessage: ''
          }
        },
        memoAndNote: {
          id: this.user.base.id,
          memos: this.user.memos,
          notes: this.user.notes
        },
        basic: {
          id: this.user.base.id,
          registeredDate: {
            input: this.user.base.registeredDate,
            errorMessage: ''
          },
          branchCode: {
            input: this.user.base.branchCode.code,
            display: this.user.base.branchCode.shortName,
            errorMessage: ''
          },
          myBranchCode: {
            input: this.user.base.myBranchCode.code,
            display: this.user.base.myBranchCode.shortName,
            errorMessage: ''
          },
          reserveReceivePlaceCode: {
            input: this.user.base.reserveReceivePlaceCode.code,
            display: this.user.base.reserveReceivePlaceCode.shortName,
            errorMessage: ''
          },
          ppid: this.user.base.ppid,
          felicaId: this.user.base.felicaId,
          birthdayJapaneseSymbol: {
            input: this.user.personal.birthdayJapaneseSymbol,
            errorMessage: ''
          },
          birthday: {
            input: this.user.personal.birthday,
            errorMessage: ''
          },
          gender: {
            input: this.user.personal.gender,
            errorMessage: ''
          },
          groupType: {
            input: this.user.group.groupType.code,
            display: this.user.group.groupType.shortName,
            errorMessage: ''
          },
          reserveNotice: {
            input: this.user.base.reserveNotice.code,
            display: this.user.base.reserveNotice.shortName,
            errorMessage: ''
          },
          myPageEnabled: {
            input: this.user.opac.myPageEnabled,
            errorMessage: ''
          },
          reserveEnabled: {
            input: this.user.opac.reserveEnabled,
            errorMessage: ''
          },
          password: {
            input: this.user.opac.password,
            errorMessage: ''
          },
          registeredPassword: this.user.opac.password,
          passwordRegisteredDate: this.user.opac.registeredDate,
          disability: {
            input: this.user.personal.disability,
            errorMessage: ''
          },
          readingSupportEnabled: {
            input: this.user.base.readingSupportEnabled,
            errorMessage: ''
          },
          numberOfGroupMembers: {
            input: String(this.user.group.groupMember.numberOfGroupMembers),
            errorMessage: ''
          },
          numberOfGroupChildren: {
            input: String(this.user.group.groupMember.numberOfGroupChildren),
            errorMessage: ''
          },
          phones: (this.state.isGroup()
            ? this.user.group.phones
            : this.user.personal.phones
          ).map(phone => ({
            id: phone.id,
            contact: phone.contact,
            number: {
              input: phone.number,
              errorMessage: ''
            },
            type: {
              input: phone.type.code,
              display: phone.type.shortName,
              errorMessage: ''
            }
          })),
          addressCode: {
            // HACK 表示はzipCode.inputだが、入力はaddressCode.inputであるため、受け取ったaddressCodeのzipCodeを上書きしておく必要がある
            // HACK 住所に関しては取り扱いがややこしい為、時間があればリファクタを検討する
            input: this.state.isGroup()
              ? Object.assign(defaultUserAddress(), {
                  ...this.user.group.userAddress.addressCode,
                  zipCode: this.user.group.userAddress.zipCode
                })
              : Object.assign(defaultUserAddress(), {
                  ...this.user.personal.userAddress.addressCode,
                  zipCode: this.user.personal.userAddress.zipCode
                }),
            errorMessage: ''
          },
          zipCode: {
            // HACK この郵便番号入力値は上記コメントの通り、厳密には「表示内容」を意味している。入力値ではない
            input: this.state.isGroup()
              ? this.user.group.userAddress.zipCode
              : this.user.personal.userAddress.zipCode,
            errorMessage: ''
          },
          areaCode: {
            input: this.state.isGroup()
              ? this.user.group.userAddress.areaCode
              : this.user.personal.userAddress.areaCode,
            errorMessage: ''
          },
          address: {
            input: this.state.isGroup()
              ? this.user.group.userAddress.address
              : this.user.personal.userAddress.address,
            errorMessage: ''
          },
          mailAddresses: (this.state.isGroup()
            ? this.user.group.mailAddresses
            : this.user.personal.mailAddresses
          ).map(mailAddress => ({
            id: mailAddress.id,
            address: {
              input: mailAddress.address,
              errorMessage: ''
            },
            reserve: mailAddress.reserve,
            newArrival: mailAddress.newArrival,
            remind: mailAddress.remind,
            notice: mailAddress.notice,
            event: mailAddress.event,
            type: {
              input: mailAddress.type.code,
              display: mailAddress.type.shortName,
              errorMessage: ''
            }
          }))
        },
        usageSituation: {
          lendTotalCount: this.user.nowStatus.lendTotalCount,
          lendTotalLimit: this.user.nowStatus.lendTotalLimit,
          insideReadingCount: this.user.nowStatus.insideReadingCount,
          reserveCount: this.user.nowStatus.reserveCount,
          lostCount: this.user.nowStatus.lostCount,
          suspendReason: {
            input: this.user.nowStatus.suspendReason.code,
            display: this.user.nowStatus.suspendReason.shortName,
            errorMessage: ''
          },
          suspendLimit: {
            input: this.user.nowStatus.suspendLimit,
            errorMessage: ''
          },
          updatedDate: this.user.nowStatus.updatedDate,
          lendDate: this.user.nowStatus.lendDate,
          remindDate: this.user.nowStatus.remindDate,
          remindExclude: {
            input: this.user.nowStatus.remindExclude,
            errorMessage: ''
          },
          remindTotal: this.user.nowStatus.remindTotal,
          remindWay: this.user.nowStatus.remindWay,
          overdueCount: this.user.nowStatus.overdueCount,
          lendCountList: this.user.nowStatus.lendCountList,
          lendLatestCount: this.user.nowStatus.lendLatestCount,
          lendLatestLimit: this.user.nowStatus.lendLatestLimit,
          lendCountHistory: this.user.lendCountHistory,
          studentLendCountHistory: this.user.studentLendCountHistory,
          remindCountHistory: this.user.remindCountHistory,
          reserveCountHistory: this.user.reserveCountHistory,
          requestReserveCountHistory: this.user.requestReserveCountHistory,
          cardLostUno: this.user.base.cardLost.uno,
          cardLostCount: {
            input: String(this.user.base.cardLost.count),
            errorMessage: ''
          },
          cardLostReissueDate: {
            input: String(this.user.base.cardLost.reissue),
            errorMessage: ''
          },
          cardLostDate: {
            input: this.user.base.cardLost.lost,
            errorMessage: ''
          }
        },
        otherContacts: {
          guardian: {
            input: this.state.isGroup()
              ? this.user.group.guardian
              : this.user.personal.guardian,
            errorMessage: ''
          },
          guardianKana: {
            input: this.state.isGroup()
              ? this.user.group.guardianKana
              : this.user.personal.guardianKana,
            errorMessage: ''
          },
          workType: {
            input: this.user.personal.workType.code,
            display: this.user.personal.workType.shortName,
            errorMessage: ''
          },
          otherContacts: (this.state.isGroup()
            ? this.user.group.otherContacts
            : this.user.personal.otherContacts
          )
            .map(otherContact => ({
              id: otherContact.id,
              type: {
                input: otherContact.type.code,
                display: otherContact.type.shortName,
                errorMessage: ''
              },
              name: {
                input: otherContact.name,
                errorMessage: ''
              }
            }))
            .reverse()
        },
        family: {
          id: this.user.base.id,
          userFamilyId: this.user.personal.userFamilyId,
          familyUsers: this.user.familyUsers
        },
        newArrivalNotice: {
          genres: this.user.newArrivalNotice.genres
            .map(genre => ({
              id: genre.id,
              genre: {
                input: genre.genre.code,
                display: genre.genre.shortName,
                errorMessage: ''
              },
              opt1: genre.opt1
            }))
            .reverse(),
          keywords: this.user.newArrivalNotice.keywords
            .map(keyword => ({
              id: keyword.id,
              keyword: {
                input: keyword.keyword,
                errorMessage: ''
              }
            }))
            .reverse(),
          magazines: this.user.newArrivalNotice.magazines
            .map(magazine => ({
              id: magazine.id,
              displayTitle: magazine.displayTitle
            }))
            .reverse()
        },
        oldName: {
          oldNames: (this.state.isGroup()
            ? this.user.group.oldNames
            : this.user.personal.oldNames
          )
            .map(oldName => ({
              id: oldName.id,
              name: {
                input: oldName.name,
                errorMessage: ''
              },
              nameKana: {
                input: oldName.nameKana,
                errorMessage: ''
              }
            }))
            .reverse(),
          oldAddresses: (this.state.isGroup()
            ? this.user.group.oldAddresses
            : this.user.personal.oldAddresses
          )
            .map(oldAddress => ({
              id: oldAddress.id,
              addressCode: {
                input: oldAddress.addressCode,
                errorMessage: ''
              },
              address: {
                input: oldAddress.address,
                errorMessage: ''
              }
            }))
            .reverse()
        },
        lending: {
          id: this.user.base.id,
          name: this.state.isGroup()
            ? this.user.group.name
            : this.user.personal.name,
          revision: this.user.base.revision,
          userType: this.user.base.userType,
          lendCollections: this.user.lendCollections,
          remindHistories: this.user.remindHistories
        },
        reserved: {
          id: this.user.base.id,
          reserveCollections: this.user.reserveCollections,
          reserveCancelCollections: this.user.reserveCancelCollections
        },
        mailHistory: {
          mailHistories: this.user.mailHistories
        },
        externalCollaboration:
          this.user.externalCollaboration.status ===
          UserExternalCollaborationStatus.Issued
            ? {
                ...defaultUserExternalCollaborationItem(),
                userId: this.$route.params.id,
                externalId: {
                  ...defaultUserExternalCollaborationItem().externalId,
                  input: this.user.externalCollaboration.externalId
                },
                externalPassword: this.user.externalCollaboration
                  .externalPassword,
                registrationDate: {
                  ...defaultUserExternalCollaborationItem().registrationDate,
                  input: this.user.externalCollaboration.registrationDate
                },
                registrationBranchCode: {
                  ...defaultUserExternalCollaborationItem()
                    .registrationBranchCode,
                  input: this.user.externalCollaboration.registrationBranchCode
                    .code,
                  display: this.user.externalCollaboration
                    .registrationBranchCode.shortName
                },
                status: this.user.externalCollaboration.status
              }
            : {
                ...defaultUserExternalCollaborationItem(),
                userId: this.$route.params.id,
                status: this.user.externalCollaboration.status
              }
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async reconfigureExternalCollaboration(): Promise<void> {
    try {
      this.user = await userApi.getUser({
        id: this.$route.params.id
      })

      const baseItem = {
        ...defaultUserExternalCollaborationItem(),
        userId: this.$route.params.id,
        status: this.user.externalCollaboration.status
      }

      if (
        this.user.externalCollaboration.status ===
        UserExternalCollaborationStatus.Issued
      ) {
        this.item.externalCollaboration = {
          ...baseItem,
          externalId: {
            ...baseItem.externalId,
            input: this.user.externalCollaboration.externalId
          },
          externalPassword: this.user.externalCollaboration.externalPassword,
          registrationDate: {
            ...baseItem.registrationDate,
            input: this.user.externalCollaboration.registrationDate
          },
          registrationBranchCode: {
            ...baseItem.registrationBranchCode,
            input: this.user.externalCollaboration.registrationBranchCode.code,
            display: this.user.externalCollaboration.registrationBranchCode
              .shortName
          }
        }
      } else {
        this.item.externalCollaboration = baseItem
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async onUpdatedLendExtend(): Promise<void> {
    await this.initialize()

    const registerRewriteCard = async () => {
      await this.$reWriteCard.register({
        parameter: {
          userNo: this.user.base.id,
          branchName: this.user.base.branchCode.name,
          collections: this.user.lendCollections.map(lendCollection => ({
            title: lendCollection.displayTitle,
            dueDate: `${lendCollection.dueDate.substr(
              0,
              4
            )}-${lendCollection.dueDate.substr(
              4,
              2
            )}-${lendCollection.dueDate.substr(6, 2)}`
          }))
        },
        isEject: false,
        registered: () => this.$eventBus.emit(PAGE_LOADING_END),
        unConnectedReaderWriter: () => this.$eventBus.emit(PAGE_LOADING_END)
      })
    }
    registerRewriteCard()
  }

  async initialize(): Promise<void> {
    if (!this.existsUserId) {
      this.state = defaultUserDetailStateInfo()
      this.user = defaultUser()
      this.item = defaultUserDetailItem()
      this.setInitialActiveTab()
      this.setTitleAndFooterActions()
      this.calculateTableHeight()
      return
    }

    if (
      this.$route?.params.id === 'create' ||
      this.$route?.params.id === 'create-group'
    ) {
      if (this.$route?.params.id === 'create') {
        this.state.state = UserDetailPageState.UserCreate
      } else if (this.$route?.params.id === 'create-group') {
        this.state.state = UserDetailPageState.GroupCreate
      }

      this.user = defaultUser()
      this.item = defaultUserDetailItem()
      // 作成処理の対応なのでsystemCodeのshortNameは考慮しなくて良い
      this.item.basic.registeredDate.input = dayjs().format('YYYYMMDD')
      this.item.basic.branchCode.input = authUserStore.authUser.branchCode.code

      if (isStrContainHiraganaOrKanji(this.searchConditions.name.input)) {
        this.item.info.name.input = this.searchConditions.name.input
      } else {
        this.item.info.nameKana.input = this.searchConditions.name.input
      }
      this.item.info.userType.input = this.searchConditions.userType.input.code
      this.item.basic.birthday.input = this.searchConditions.birthday.input
      this.item.basic.gender.input = this.searchConditions.gender.input
      this.item.basic.address.input = this.searchConditions.address.input

      // どのような入力があろうが必ず一件は設定する必要があるので間違いはない
      if (dataStore.displayUserSearchPagePhone) {
        this.item.basic.phones = [
          Object.assign(defaultUserPhoneTableItem(), {
            contact: true,
            number: {
              input: this.searchConditions.phoneNumber.input,
              errorMessage: ''
            }
          })
        ]
      }
      this.item.otherContacts.otherContacts = [
        defaultUserOtherContactsTableItem()
      ]

      if (this.state.isUserCreate()) {
        this.item.info.studentGrade.input = this.searchConditions.studentGrade.input.code
        this.item.info.studentClass.input = this.searchConditions.studentClass.input.code
        this.item.info.studentNumber.input = this.searchConditions.studentNumber.input
      }
    } else {
      await this.fetchUser()
      this.alertOldId()
    }

    if (this.state.isUpdate()) {
      if (this.item.otherContacts.otherContacts.length === 0) {
        this.item.otherContacts.otherContacts = [
          defaultUserOtherContactsTableItem()
        ]
      }
    }

    this.setInitialActiveTab()

    this.setTitleAndFooterActions()

    this.calculateTableHeight()
  }

  callUserSearch(id: string) {
    if (document.activeElement !== null) {
      ;(document.activeElement as any).blur()
    }

    this.$eventBus.emit(PAGE_LOADING_START)

    if (id === this.$route.params.id) {
      this.initialize()
      return
    }

    this.$router.push(`/user/${id}`)
  }

  onClickUserSearch(): void {
    this.$modalUserSearch.open({
      onClickOk: (userId: string) => {
        this.callUserSearch(userId)
      },
      onClickCancel: (updatedUserIds: string[]) => {
        if (updatedUserIds.some(id => id === this.$route.params.id)) {
          this.initialize()
        }
      }
    })
  }

  async copyOtherUserInfo(id: string) {
    try {
      const user = await userApi.getUser({ id })
      this.item.basic.phones = (this.state.isGroup()
        ? user.group.phones
        : user.personal.phones
      ).map(phone => ({
        id: phone.id,
        contact: phone.contact,
        number: {
          input: phone.number,
          errorMessage: ''
        },
        type: {
          input: phone.type.code,
          display: phone.type.shortName,
          errorMessage: ''
        }
      }))
      this.item.basic.addressCode.input = this.state.isGroup()
        ? user.group.userAddress.addressCode
        : user.personal.userAddress.addressCode
      this.item.basic.zipCode.input = this.state.isGroup()
        ? user.group.userAddress.zipCode
        : user.personal.userAddress.zipCode
      this.item.basic.areaCode.input = this.state.isGroup()
        ? user.group.userAddress.areaCode
        : user.personal.userAddress.areaCode
      this.item.basic.address.input = this.state.isGroup()
        ? user.group.userAddress.address
        : user.personal.userAddress.address
      this.item.otherContacts.guardian.input = this.state.isGroup()
        ? user.group.guardian
        : user.personal.guardian
      this.item.otherContacts.guardianKana.input = this.state.isGroup()
        ? user.group.guardianKana
        : user.personal.guardianKana
      this.item.otherContacts.otherContacts = (this.state.isGroup()
        ? user.group.otherContacts
        : user.personal.otherContacts
      )
        .map(otherContact => ({
          id: otherContact.id,
          type: {
            input: otherContact.type.code,
            display: otherContact.type.shortName,
            errorMessage: ''
          },
          name: {
            input: otherContact.name,
            errorMessage: ''
          }
        }))
        .reverse()

      if (this.item.otherContacts.otherContacts.length === 0) {
        this.item.otherContacts.otherContacts = [
          defaultUserOtherContactsTableItem()
        ]
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  goUserListPage() {
    if (this.processingIcTag) {
      return
    }
    this.$router.push(`/user`)
  }

  goUserDetailPage() {
    if (this.processingIcTag) {
      return
    }

    let path = ''
    let title = ''

    if (this.state.isCreate()) {
      path = `/user/${this.item.info.userId.input}`
      title = this.item.info.name.input
    } else {
      path = `/user/${this.user.base.id}`
      title = this.state.isGroup()
        ? this.user.group.name
        : this.user.personal.name
    }

    this.$router.push({
      path,
      query: {
        title,
        page: undefined,
        pined: this.$route.query?.pined
      }
    })
  }

  prev(): void {
    // eslint-disable-next-line standard/computed-property-even-spacing
    const prevUser: UserSearchTableItemData = this.searchResult.sortedItems()[
      this.currentPage - 2
    ]

    this.$router.push({
      path: `/user/${prevUser.id}`,
      query: {
        title: prevUser.name
      }
    })
  }

  next(): void {
    // eslint-disable-next-line standard/computed-property-even-spacing
    const nextUser: UserSearchTableItemData = this.searchResult.sortedItems()[
      this.currentPage
    ]

    this.$router.push({
      path: `/user/${nextUser.id}`,
      query: {
        title: nextUser.name
      }
    })
  }

  async userCreate(_ignoreDuplicateCheck: boolean = false, func?: Function) {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await userApi.createUser({
        id: this.item.info.userId.input,
        userType: this.item.info.userType.input,
        expirationDate: this.item.info.expirationDate.input,
        state: this.item.info.userStatus.input.code,
        studentGrade: this.item.info.studentGrade.input,
        studentClass: this.item.info.studentClass.input,
        studentNumber: this.item.info.studentNumber.input,
        registeredDate: this.item.basic.registeredDate.input,
        branchCode: this.item.basic.branchCode.input,
        myBranchCode: this.item.basic.myBranchCode.input,
        myPlaceCode: this.user.base.myPlaceCode.code, // TODO ここは入力値が無いのでそのまま設定している
        reserveReceivePlaceCode: this.item.basic.reserveReceivePlaceCode.input,
        name: this.item.info.name.input,
        nameKana: this.item.info.nameKana.input,
        birthday:
          this.item.basic.birthdayJapaneseSymbol.input.code +
          this.item.basic.birthday.input,
        gender: this.item.basic.gender.input.code,
        phoneNumbers: this.item.basic.phones.map(phone => ({
          id: phone.id,
          contact: phone.contact,
          number: phone.number.input,
          type: phone.type.input
        })),
        addressCode: this.item.basic.addressCode.input.code,
        zipCode: this.item.basic.zipCode.input,
        areaCode: this.item.basic.areaCode.input.code,
        address: this.item.basic.address.input,
        mailAddresses: this.item.basic.mailAddresses.map(mailAddress => ({
          id: mailAddress.id,
          address: mailAddress.address.input,
          reserve: mailAddress.reserve,
          newArrival: mailAddress.newArrival,
          remind: mailAddress.remind,
          notice: mailAddress.notice,
          event: mailAddress.event,
          type: mailAddress.type.input
        })),
        reserveNotice: this.item.basic.reserveNotice.input,
        opacPassword: this.item.basic.password.input,
        opacMyPageEnabled: this.item.basic.myPageEnabled.input,
        opacMyReserveEnabled: this.item.basic.reserveEnabled.input,
        remindExclude: this.item.usageSituation.remindExclude.input.code,
        suspendReason: this.item.usageSituation.suspendReason.input,
        suspendLimit: this.item.usageSituation.suspendLimit.input,
        cardLostCount: Number(this.item.usageSituation.cardLostCount.input),
        cardLostReissue: this.item.usageSituation.cardLostReissueDate.input,
        cardLostDate: this.item.usageSituation.cardLostDate.input,
        disability: this.item.basic.disability.input,
        readingSupportEnabled: this.item.basic.readingSupportEnabled.input,
        guardian: this.item.otherContacts.guardian.input,
        guardianKana: this.item.otherContacts.guardianKana.input,
        workType: this.item.otherContacts.workType.input,
        otherContacts: this.item.otherContacts.otherContacts
          .filter(
            otherContact =>
              otherContact.type.input !== '' || otherContact.name.input !== ''
          )
          .map(otherContact => ({
            id: otherContact.id,
            type: otherContact.type.input,
            name: otherContact.name.input
          })),
        userFamilyId: this.item.family.userFamilyId,
        familyUsers: this.item.family.familyUsers.map(familyUser => ({
          id: familyUser.base.id
        })),
        userOldNames: this.item.oldName.oldNames.map(oldName => ({
          id: oldName.id,
          name: oldName.name.input,
          nameKana: oldName.nameKana.input
        })),
        userOldAddresses: this.item.oldName.oldAddresses.map(oldAddress => ({
          id: oldAddress.id,
          addressCode: oldAddress.addressCode.input.code,
          address: oldAddress.address.input
        })),
        userNewArrivalNoticeGenres: this.item.newArrivalNotice.genres.map(
          genre => genre.genre.input
        ),
        userNewArrivalNoticeKeywords: this.item.newArrivalNotice.keywords.map(
          keyword => keyword.keyword.input
        ),
        _ignoreDuplicateCheck
      })

      this.isUserUpdated = true

      if (!this.processingIcTag && reWriteCardStore.loaded) {
        this.$reWriteCard.register({
          parameter: {
            userNo: this.item.info.userId.input,
            branchName:
              systemCodeStore.findByCodeKeyAndCode(
                CODE_KEY.LIBRARY_BRANCH.KEY,
                this.item.basic.branchCode.input
              )?.name ?? '',
            collections: []
          },
          isEject: false,
          registered: this.goUserDetailPage,
          unConnectedReaderWriter: this.goUserDetailPage
        })
      } else {
        this.goUserDetailPage()

        if (func) {
          func()
        }

        this.$eventBus.emit(PAGE_LOADING_END)
      }
    } catch (error) {
      this.$eventBus.emit(PAGE_LOADING_END)
      if (error instanceof AlertMessage) {
        if (
          error.alerts.length === 1 &&
          error.alerts[0].code === AlertCodeAL400023
        ) {
          alertStore.setItem(error.alerts[0])
          this.$modalAlert.open({
            onOkClick: () => {
              this.userCreate(true, func)
            }
          })
          return
        }
        setErrorMessage(error.alerts, {
          id: this.item.info.userId,
          userType: this.item.info.userType,
          expirationDate: this.item.info.expirationDate,
          state: this.item.info.userStatus,
          studentGrade: this.item.info.studentGrade,
          studentClass: this.item.info.studentClass,
          studentNumber: this.item.info.studentNumber,
          registeredDate: this.item.basic.registeredDate,
          branchCode: this.item.basic.branchCode,
          myBranchCode: this.item.basic.myBranchCode,
          myPlaceCode: this.user.base.myPlaceCode, // TODO ここは入力値が無いのでそのまま設定している
          reserveReceivePlaceCode: this.item.basic.reserveReceivePlaceCode,
          name: this.item.info.name,
          nameKana: this.item.info.nameKana,
          birthday: this.item.basic.birthday,
          gender: this.item.basic.gender,
          phoneNumbers: this.item.basic.phones.map(phone => ({
            id: phone.id,
            contact: phone.contact,
            number: phone.number,
            type: phone.type
          })),
          addressCode: this.item.basic.addressCode,
          zipCode: this.item.basic.zipCode,
          areaCode: this.item.basic.areaCode,
          address: this.item.basic.address,
          mailAddresses: this.item.basic.mailAddresses.map(mailAddress => ({
            id: mailAddress.id,
            address: mailAddress.address,
            reserve: mailAddress.reserve,
            newArrival: mailAddress.newArrival,
            remind: mailAddress.remind,
            notice: mailAddress.notice,
            event: mailAddress.event,
            type: mailAddress.type
          })),
          reserveNotice: this.item.basic.reserveNotice,
          opacPassword: this.item.basic.password,
          opacMyPageEnabled: this.item.basic.myPageEnabled,
          opacMyReserveEnabled: this.item.basic.reserveEnabled,
          remindExclude: this.item.usageSituation.remindExclude,
          suspendReason: this.item.usageSituation.suspendReason,
          suspendLimit: this.item.usageSituation.suspendLimit,
          cardLostCount: Number(this.item.usageSituation.cardLostCount),
          cardLostReissue: this.item.usageSituation.cardLostReissueDate,
          cardLostDate: this.item.usageSituation.cardLostDate,
          disability: this.item.basic.disability,
          readingSupportEnabled: this.item.basic.readingSupportEnabled,
          guardian: this.item.otherContacts.guardian,
          guardianKana: this.item.otherContacts.guardianKana,
          workType: this.item.otherContacts.workType,
          otherContacts: this.item.otherContacts.otherContacts
            .filter(
              otherContact =>
                otherContact.type.input !== '' || otherContact.name.input !== ''
            )
            .map(otherContact => ({
              id: otherContact.id,
              type: otherContact.type,
              name: otherContact.name
            })),
          userFamilyId: this.item.family.userFamilyId,
          familyUsers: this.item.family.familyUsers.map(familyUser => ({
            id: familyUser.base.id
          })),
          userOldNames: this.item.oldName.oldNames.map(oldName => ({
            id: oldName.id,
            name: oldName.name,
            nameKana: oldName.nameKana
          })),
          userOldAddresses: this.item.oldName.oldAddresses.map(oldAddress => ({
            id: oldAddress.id,
            addressCode: oldAddress.addressCode,
            address: oldAddress.address
          })),
          userNewArrivalNoticeGenres: this.item.newArrivalNotice.genres.map(
            genre => genre.genre
          ),
          userNewArrivalNoticeKeywords: this.item.newArrivalNotice.keywords.map(
            keyword => keyword.keyword
          )
        })
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
      throw error
    }
  }

  async userUpdate() {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await userApi.updateUser({
        id: this.item.info.userId.input,
        userType: this.item.info.userType.input,
        expirationDate: this.item.info.expirationDate.input,
        state: this.item.info.userStatus.input.code,
        studentGrade: this.item.info.studentGrade.input,
        studentClass: this.item.info.studentClass.input,
        studentNumber: this.item.info.studentNumber.input,
        registeredDate: this.item.basic.registeredDate.input,
        branchCode: this.item.basic.branchCode.input,
        myBranchCode: this.item.basic.myBranchCode.input,
        myPlaceCode: this.user.base.myPlaceCode.code, // TODO ここは入力値が無いのでそのまま設定している
        reserveReceivePlaceCode: this.item.basic.reserveReceivePlaceCode.input,
        name: this.item.info.name.input,
        nameKana: this.item.info.nameKana.input,
        birthday:
          this.item.basic.birthdayJapaneseSymbol.input.code +
          this.item.basic.birthday.input,
        gender: this.item.basic.gender.input.code,
        phoneNumbers: this.item.basic.phones.map(phone => ({
          id: phone.id,
          contact: phone.contact,
          number: phone.number.input,
          type: phone.type.input
        })),
        addressCode: this.item.basic.addressCode.input.code,
        zipCode: this.item.basic.zipCode.input,
        areaCode: this.item.basic.areaCode.input.code,
        address: this.item.basic.address.input,
        mailAddresses: this.item.basic.mailAddresses.map(mailAddress => ({
          id: mailAddress.id,
          address: mailAddress.address.input,
          reserve: mailAddress.reserve,
          newArrival: mailAddress.newArrival,
          remind: mailAddress.remind,
          notice: mailAddress.notice,
          event: mailAddress.event,
          type: mailAddress.type.input
        })),
        reserveNotice: this.item.basic.reserveNotice.input,
        opacPassword: this.item.basic.password.input,
        opacMyPageEnabled: this.item.basic.myPageEnabled.input,
        opacMyReserveEnabled: this.item.basic.reserveEnabled.input,
        remindExclude: this.item.usageSituation.remindExclude.input.code,
        suspendReason: this.item.usageSituation.suspendReason.input,
        suspendLimit: this.item.usageSituation.suspendLimit.input,
        cardLostCount: Number(this.item.usageSituation.cardLostCount.input),
        cardLostReissue: this.item.usageSituation.cardLostReissueDate.input,
        cardLostDate: this.item.usageSituation.cardLostDate.input,
        disability: this.item.basic.disability.input,
        readingSupportEnabled: this.item.basic.readingSupportEnabled.input,
        guardian: this.item.otherContacts.guardian.input,
        guardianKana: this.item.otherContacts.guardianKana.input,
        workType: this.item.otherContacts.workType.input,
        otherContacts: this.item.otherContacts.otherContacts
          .filter(
            otherContact =>
              otherContact.type.input !== '' || otherContact.name.input !== ''
          )
          .map(otherContact => ({
            id: otherContact.id,
            type: otherContact.type.input,
            name: otherContact.name.input
          })),
        userFamilyId: this.item.family.userFamilyId,
        familyUsers: this.item.family.familyUsers.map(familyUser => ({
          id: familyUser.base.id
        })),
        userOldNames: this.item.oldName.oldNames.map(oldName => ({
          id: oldName.id,
          name: oldName.name.input,
          nameKana: oldName.nameKana.input
        })),
        userOldAddresses: this.item.oldName.oldAddresses.map(oldAddress => ({
          id: oldAddress.id,
          addressCode: oldAddress.addressCode.input.code,
          address: oldAddress.address.input
        })),
        userNewArrivalNoticeGenres: this.item.newArrivalNotice.genres.map(
          genre => genre.genre.input
        ),
        userNewArrivalNoticeKeywords: this.item.newArrivalNotice.keywords.map(
          keyword => keyword.keyword.input
        ),
        revision: this.user.base.revision
      })

      this.isUserUpdated = true

      this.goUserDetailPage()
    } catch (error) {
      if (error instanceof AlertMessage) {
        setErrorMessage(error.alerts, {
          id: this.item.info.userId,
          userType: this.item.info.userType,
          expirationDate: this.item.info.expirationDate,
          state: this.item.info.userStatus,
          studentGrade: this.item.info.studentGrade,
          studentClass: this.item.info.studentClass,
          studentNumber: this.item.info.studentNumber,
          registeredDate: this.item.basic.registeredDate,
          branchCode: this.item.basic.branchCode,
          myBranchCode: this.item.basic.myBranchCode,
          myPlaceCode: this.user.base.myPlaceCode, // TODO ここは入力値が無いのでそのまま設定している
          reserveReceivePlaceCode: this.item.basic.reserveReceivePlaceCode,
          name: this.item.info.name,
          nameKana: this.item.info.nameKana,
          birthday: this.item.basic.birthday,
          gender: this.item.basic.gender,
          phoneNumbers: this.item.basic.phones.map(phone => ({
            id: phone.id,
            contact: phone.contact,
            number: phone.number,
            type: phone.type
          })),
          addressCode: this.item.basic.addressCode,
          zipCode: this.item.basic.zipCode,
          areaCode: this.item.basic.areaCode,
          address: this.item.basic.address,
          mailAddresses: this.item.basic.mailAddresses.map(mailAddress => ({
            id: mailAddress.id,
            address: mailAddress.address,
            reserve: mailAddress.reserve,
            newArrival: mailAddress.newArrival,
            remind: mailAddress.remind,
            notice: mailAddress.notice,
            event: mailAddress.event,
            type: mailAddress.type
          })),
          reserveNotice: this.item.basic.reserveNotice,
          opacPassword: this.item.basic.password,
          opacMyPageEnabled: this.item.basic.myPageEnabled,
          opacMyReserveEnabled: this.item.basic.reserveEnabled,
          remindExclude: this.item.usageSituation.remindExclude,
          suspendReason: this.item.usageSituation.suspendReason,
          suspendLimit: this.item.usageSituation.suspendLimit,
          cardLostCount: Number(this.item.usageSituation.cardLostCount),
          cardLostReissue: this.item.usageSituation.cardLostReissueDate,
          cardLostDate: this.item.usageSituation.cardLostDate,
          disability: this.item.basic.disability,
          readingSupportEnabled: this.item.basic.readingSupportEnabled,
          guardian: this.item.otherContacts.guardian,
          guardianKana: this.item.otherContacts.guardianKana,
          workType: this.item.otherContacts.workType,
          otherContacts: this.item.otherContacts.otherContacts
            .filter(
              otherContact =>
                otherContact.type.input !== '' || otherContact.name.input !== ''
            )
            .map(otherContact => ({
              id: otherContact.id,
              type: otherContact.type,
              name: otherContact.name
            })),
          userFamilyId: this.item.family.userFamilyId,
          familyUsers: this.item.family.familyUsers.map(familyUser => ({
            id: familyUser.base.id
          })),
          userOldNames: this.item.oldName.oldNames.map(oldName => ({
            id: oldName.id,
            name: oldName.name,
            nameKana: oldName.nameKana
          })),
          userOldAddresses: this.item.oldName.oldAddresses.map(oldAddress => ({
            id: oldAddress.id,
            addressCode: oldAddress.addressCode,
            address: oldAddress.address
          })),
          userNewArrivalNoticeGenres: this.item.newArrivalNotice.genres.map(
            genre => genre.genre
          ),
          userNewArrivalNoticeKeywords: this.item.newArrivalNotice.keywords.map(
            keyword => keyword.keyword
          )
        })
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }

      throw error
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async groupCreate() {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await userApi.createGroup({
        id: this.item.info.userId.input,
        userType: this.item.info.userType.input,
        expirationDate: this.item.info.expirationDate.input,
        state: this.item.info.userStatus.input.code,
        registeredDate: this.item.basic.registeredDate.input,
        branchCode: this.item.basic.branchCode.input,
        myBranchCode: this.item.basic.myBranchCode.input,
        myPlaceCode: this.user.base.myPlaceCode.code, // TODO ここは入力値が無いのでそのまま設定している
        reserveReceivePlaceCode: this.item.basic.reserveReceivePlaceCode.input,
        name: this.item.info.name.input,
        nameKana: this.item.info.nameKana.input,
        phoneNumbers: this.item.basic.phones.map(phone => ({
          id: phone.id,
          contact: phone.contact,
          number: phone.number.input,
          type: phone.type.input
        })),
        addressCode: this.item.basic.addressCode.input.code,
        zipCode: this.item.basic.zipCode.input,
        areaCode: this.item.basic.areaCode.input.code,
        address: this.item.basic.address.input,
        groupType: this.item.basic.groupType.input,
        numberOfGroupMembers: Number(
          this.item.basic.numberOfGroupMembers.input
        ),
        numberOfGroupChildren: Number(
          this.item.basic.numberOfGroupChildren.input
        ),
        mailAddresses: this.item.basic.mailAddresses.map(mailAddress => ({
          id: mailAddress.id,
          address: mailAddress.address.input,
          reserve: mailAddress.reserve,
          newArrival: mailAddress.newArrival,
          remind: mailAddress.remind,
          notice: mailAddress.notice,
          event: mailAddress.event,
          type: mailAddress.type.input
        })),
        reserveNotice: this.item.basic.reserveNotice.input,
        opacPassword: this.item.basic.password.input,
        opacMyPageEnabled: this.item.basic.myPageEnabled.input,
        opacMyReserveEnabled: this.item.basic.reserveEnabled.input,
        remindExclude: this.item.usageSituation.remindExclude.input.code,
        suspendReason: this.item.usageSituation.suspendReason.input,
        suspendLimit: this.item.usageSituation.suspendLimit.input,
        cardLostCount: Number(this.item.usageSituation.cardLostCount.input),
        cardLostReissue: this.item.usageSituation.cardLostReissueDate.input,
        cardLostDate: this.item.usageSituation.cardLostDate.input,
        readingSupportEnabled: this.item.basic.readingSupportEnabled.input,
        guardian: this.item.otherContacts.guardian.input,
        guardianKana: this.item.otherContacts.guardianKana.input,
        otherContacts: this.item.otherContacts.otherContacts
          .filter(
            otherContact =>
              otherContact.type.input !== '' || otherContact.name.input !== ''
          )
          .map(otherContact => ({
            id: otherContact.id,
            type: otherContact.type.input,
            name: otherContact.name.input
          })),
        userOldNames: this.item.oldName.oldNames.map(oldName => ({
          id: oldName.id,
          name: oldName.name.input,
          nameKana: oldName.nameKana.input
        })),
        userOldAddresses: this.item.oldName.oldAddresses.map(oldAddress => ({
          id: oldAddress.id,
          addressCode: oldAddress.addressCode.input.code,
          address: oldAddress.address.input
        })),
        userNewArrivalNoticeGenres: this.item.newArrivalNotice.genres.map(
          genre => genre.genre.input
        ),
        userNewArrivalNoticeKeywords: this.item.newArrivalNotice.keywords.map(
          keyword => keyword.keyword.input
        )
      })

      this.isUserUpdated = true

      if (!this.processingIcTag && reWriteCardStore.loaded) {
        this.$reWriteCard.register({
          parameter: {
            userNo: this.item.info.userId.input,
            branchName:
              systemCodeStore.findByCodeKeyAndCode(
                CODE_KEY.LIBRARY_BRANCH.KEY,
                this.item.basic.branchCode.input
              )?.name ?? '',
            collections: []
          },
          isEject: false,
          registered: this.goUserDetailPage,
          unConnectedReaderWriter: this.goUserDetailPage
        })
      } else {
        this.goUserDetailPage()
        this.$eventBus.emit(PAGE_LOADING_END)
      }
    } catch (error) {
      this.$eventBus.emit(PAGE_LOADING_END)
      if (error instanceof AlertMessage) {
        setErrorMessage(error.alerts, {
          id: this.item.info.userId,
          userType: this.item.info.userType,
          expirationDate: this.item.info.expirationDate,
          state: this.item.info.userStatus,
          registeredDate: this.item.basic.registeredDate,
          branchCode: this.item.basic.branchCode,
          myBranchCode: this.item.basic.myBranchCode,
          myPlaceCode: this.user.base.myPlaceCode, // TODO ここは入力値が無いのでそのまま設定している
          reserveReceivePlaceCode: this.item.basic.reserveReceivePlaceCode,
          name: this.item.info.name,
          nameKana: this.item.info.nameKana,
          phoneNumbers: this.item.basic.phones.map(phone => ({
            id: phone.id,
            contact: phone.contact,
            number: phone.number,
            type: phone.type
          })),
          addressCode: this.item.basic.addressCode,
          zipCode: this.item.basic.zipCode,
          areaCode: this.item.basic.areaCode,
          address: this.item.basic.address,
          groupType: this.item.basic.groupType,
          numberOfGroupMembers: this.item.basic.numberOfGroupMembers,
          numberOfGroupChildren: this.item.basic.numberOfGroupChildren,
          mailAddresses: this.item.basic.mailAddresses.map(mailAddress => ({
            id: mailAddress.id,
            address: mailAddress.address,
            reserve: mailAddress.reserve,
            newArrival: mailAddress.newArrival,
            remind: mailAddress.remind,
            notice: mailAddress.notice,
            event: mailAddress.event,
            type: mailAddress.type
          })),
          reserveNotice: this.item.basic.reserveNotice,
          opacPassword: this.item.basic.password,
          opacMyPageEnabled: this.item.basic.myPageEnabled,
          opacMyReserveEnabled: this.item.basic.reserveEnabled,
          remindExclude: this.item.usageSituation.remindExclude,
          suspendReason: this.item.usageSituation.suspendReason,
          suspendLimit: this.item.usageSituation.suspendLimit,
          cardLostCount: Number(this.item.usageSituation.cardLostCount),
          cardLostReissue: this.item.usageSituation.cardLostReissueDate,
          cardLostDate: this.item.usageSituation.cardLostDate,
          readingSupportEnabled: this.item.basic.readingSupportEnabled,
          guardian: this.item.otherContacts.guardian,
          guardianKana: this.item.otherContacts.guardianKana,
          otherContacts: this.item.otherContacts.otherContacts
            .filter(
              otherContact =>
                otherContact.type.input !== '' || otherContact.name.input !== ''
            )
            .map(otherContact => ({
              id: otherContact.id,
              type: otherContact.type,
              name: otherContact.name
            })),
          userOldNames: this.item.oldName.oldNames.map(oldName => ({
            id: oldName.id,
            name: oldName.name,
            nameKana: oldName.nameKana
          })),
          userOldAddresses: this.item.oldName.oldAddresses.map(oldAddress => ({
            id: oldAddress.id,
            addressCode: oldAddress.addressCode,
            address: oldAddress.address
          })),
          userNewArrivalNoticeGenres: this.item.newArrivalNotice.genres.map(
            genre => genre.genre
          ),
          userNewArrivalNoticeKeywords: this.item.newArrivalNotice.keywords.map(
            keyword => keyword.keyword
          )
        })
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
      throw error
    }
  }

  async groupUpdate() {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await userApi.updateGroup({
        id: this.item.info.userId.input,
        userType: this.item.info.userType.input,
        expirationDate: this.item.info.expirationDate.input,
        state: this.item.info.userStatus.input.code,
        registeredDate: this.item.basic.registeredDate.input,
        branchCode: this.item.basic.branchCode.input,
        myBranchCode: this.item.basic.myBranchCode.input,
        myPlaceCode: this.user.base.myPlaceCode.code, // TODO ここは入力値が無いのでそのまま設定している
        reserveReceivePlaceCode: this.item.basic.reserveReceivePlaceCode.input,
        name: this.item.info.name.input,
        nameKana: this.item.info.nameKana.input,
        phoneNumbers: this.item.basic.phones.map(phone => ({
          id: phone.id,
          contact: phone.contact,
          number: phone.number.input,
          type: phone.type.input
        })),
        addressCode: this.item.basic.addressCode.input.code,
        zipCode: this.item.basic.zipCode.input,
        areaCode: this.item.basic.areaCode.input.code,
        address: this.item.basic.address.input,
        groupType: this.item.basic.groupType.input,
        numberOfGroupMembers: Number(
          this.item.basic.numberOfGroupMembers.input
        ),
        numberOfGroupChildren: Number(
          this.item.basic.numberOfGroupChildren.input
        ),
        mailAddresses: this.item.basic.mailAddresses.map(mailAddress => ({
          id: mailAddress.id,
          address: mailAddress.address.input,
          reserve: mailAddress.reserve,
          newArrival: mailAddress.newArrival,
          remind: mailAddress.remind,
          notice: mailAddress.notice,
          event: mailAddress.event,
          type: mailAddress.type.input
        })),
        reserveNotice: this.item.basic.reserveNotice.input,
        opacPassword: this.item.basic.password.input,
        opacMyPageEnabled: this.item.basic.myPageEnabled.input,
        opacMyReserveEnabled: this.item.basic.reserveEnabled.input,
        remindExclude: this.item.usageSituation.remindExclude.input.code,
        suspendReason: this.item.usageSituation.suspendReason.input,
        suspendLimit: this.item.usageSituation.suspendLimit.input,
        cardLostCount: Number(this.item.usageSituation.cardLostCount.input),
        cardLostReissue: this.item.usageSituation.cardLostReissueDate.input,
        cardLostDate: this.item.usageSituation.cardLostDate.input,
        readingSupportEnabled: this.item.basic.readingSupportEnabled.input,
        guardian: this.item.otherContacts.guardian.input,
        guardianKana: this.item.otherContacts.guardianKana.input,
        otherContacts: this.item.otherContacts.otherContacts
          .filter(
            otherContact =>
              otherContact.type.input !== '' || otherContact.name.input !== ''
          )
          .map(otherContact => ({
            id: otherContact.id,
            type: otherContact.type.input,
            name: otherContact.name.input
          })),
        userOldNames: this.item.oldName.oldNames.map(oldName => ({
          id: oldName.id,
          name: oldName.name.input,
          nameKana: oldName.nameKana.input
        })),
        userOldAddresses: this.item.oldName.oldAddresses.map(oldAddress => ({
          id: oldAddress.id,
          addressCode: oldAddress.addressCode.input.code,
          address: oldAddress.address.input
        })),
        userNewArrivalNoticeGenres: this.item.newArrivalNotice.genres.map(
          genre => genre.genre.input
        ),
        userNewArrivalNoticeKeywords: this.item.newArrivalNotice.keywords.map(
          keyword => keyword.keyword.input
        ),
        revision: this.user.base.revision
      })

      this.isUserUpdated = true

      this.goUserDetailPage()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        setErrorMessage(error.alerts, {
          id: this.item.info.userId,
          userType: this.item.info.userType,
          expirationDate: this.item.info.expirationDate,
          state: this.item.info.userStatus,
          registeredDate: this.item.basic.registeredDate,
          branchCode: this.item.basic.branchCode,
          myBranchCode: this.item.basic.myBranchCode,
          myPlaceCode: this.user.base.myPlaceCode, // TODO ここは入力値が無いのでそのまま設定している
          reserveReceivePlaceCode: this.item.basic.reserveReceivePlaceCode,
          name: this.item.info.name,
          nameKana: this.item.info.nameKana,
          phoneNumbers: this.item.basic.phones.map(phone => ({
            id: phone.id,
            contact: phone.contact,
            number: phone.number,
            type: phone.type
          })),
          addressCode: this.item.basic.addressCode,
          zipCode: this.item.basic.zipCode,
          areaCode: this.item.basic.areaCode,
          address: this.item.basic.address,
          groupType: this.item.basic.groupType,
          numberOfGroupMembers: this.item.basic.numberOfGroupMembers,
          numberOfGroupChildren: this.item.basic.numberOfGroupChildren,
          mailAddresses: this.item.basic.mailAddresses.map(mailAddress => ({
            id: mailAddress.id,
            address: mailAddress.address,
            reserve: mailAddress.reserve,
            newArrival: mailAddress.newArrival,
            remind: mailAddress.remind,
            notice: mailAddress.notice,
            event: mailAddress.event,
            type: mailAddress.type
          })),
          reserveNotice: this.item.basic.reserveNotice,
          opacPassword: this.item.basic.password,
          opacMyPageEnabled: this.item.basic.myPageEnabled,
          opacMyReserveEnabled: this.item.basic.reserveEnabled,
          remindExclude: this.item.usageSituation.remindExclude,
          suspendReason: this.item.usageSituation.suspendReason,
          suspendLimit: this.item.usageSituation.suspendLimit,
          cardLostCount: Number(this.item.usageSituation.cardLostCount),
          cardLostReissue: this.item.usageSituation.cardLostReissueDate,
          cardLostDate: this.item.usageSituation.cardLostDate,
          readingSupportEnabled: this.item.basic.readingSupportEnabled,
          guardian: this.item.otherContacts.guardian,
          guardianKana: this.item.otherContacts.guardianKana,
          otherContacts: this.item.otherContacts.otherContacts
            .filter(
              otherContact =>
                otherContact.type.input !== '' || otherContact.name.input !== ''
            )
            .map(otherContact => ({
              id: otherContact.id,
              type: otherContact.type,
              name: otherContact.name
            })),
          userOldNames: this.item.oldName.oldNames.map(oldName => ({
            id: oldName.id,
            name: oldName.name,
            nameKana: oldName.nameKana
          })),
          userOldAddresses: this.item.oldName.oldAddresses.map(oldAddress => ({
            id: oldAddress.id,
            addressCode: oldAddress.addressCode,
            address: oldAddress.address
          })),
          userNewArrivalNoticeGenres: this.item.newArrivalNotice.genres.map(
            genre => genre.genre
          ),
          userNewArrivalNoticeKeywords: this.item.newArrivalNotice.keywords.map(
            keyword => keyword.keyword
          )
        })
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }

      throw error
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async userDelete() {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await userApi.deleteUser({
        id: this.user.base.id
      })

      this.isUserUpdated = true
      await userStore.researchUsers()
      userStore.removePinedNavigationItems(this.user.base.id)

      if (userStore.openedNavigationItem.id === this.user.base.id) {
        userStore.resetOpenedNavigationItem()
      }

      this.goUserListPage()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }

      throw error
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async separateName(): Promise<void> {
    if (
      this.item.info.name.input === '' ||
      this.item.info.nameKana.input !== ''
    ) {
      return
    }

    const separateKeywords: SeparateKeyword[] = await separateApi.separateKana({
      keywords: [
        {
          key: 'userNameKana',
          tag: 'userNameKana',
          word: this.item.info.name.input
        }
      ]
    })

    if (separateKeywords.length > 0) {
      this.item.info.nameKana.input = separateKeywords[0].value
    }
  }

  async separateGuardianName(): Promise<void> {
    if (
      this.item.otherContacts.guardian.input === '' ||
      this.item.otherContacts.guardianKana.input !== ''
    ) {
      return
    }

    const separateKeywords: SeparateKeyword[] = await separateApi.separateKana({
      keywords: [
        {
          key: 'guardianKana',
          tag: 'guardianKana',
          word: this.item.otherContacts.guardian.input
        }
      ]
    })

    if (separateKeywords.length > 0) {
      this.item.otherContacts.guardianKana.input = separateKeywords[0].value
    }
  }

  async separateOldName(): Promise<void> {
    const keywords: Keyword[] = []

    this.item.oldName.oldNames.forEach(
      (item: UserOldNameTableItem, index: number) => {
        if (item.name.input === '' || item.nameKana.input !== '') {
          return
        }

        keywords.push({
          key: 'userOldName',
          tag: index + '',
          word: item.name.input
        })
      }
    )

    if (keywords.length === 0) return

    const separateKeywords: SeparateKeyword[] = await separateApi.separateKana({
      keywords
    })

    separateKeywords.forEach(item => {
      this.item.oldName.oldNames[Number(item.tag)].nameKana.input = item.value
    })
  }

  async processReserve(bibliographyId: number): Promise<void> {
    if (systemParameterStore.displayModalSelectReserveType) {
      this.$eventBus.emit(PAGE_LOADING_START)

      try {
        const response: BibliographyRealReserveSetGroup = await bibliographyRealApi.getBibliographyRealReserveSetGroup(
          {
            id: bibliographyId
          }
        )

        if (
          response.reserveSets.length > 0 ||
          response.reserveGroups.length > 0
        ) {
          this.modalSelectReserveType.open({
            bibliographyRealId: bibliographyId,
            reserveGroupSet: response,
            onOkClick: (
              bibliographies: ReserveBibliography[],
              reserveSetId?: number,
              reserveGroupId?: number
            ) => {
              this.modalReserve.open({
                editableUserId: this.user.base.id,
                bibliographies,
                reservable: true,
                onClosed: () => (this.activeTab = this.tabType.Reserved),
                onChangedReserveInfo: this.initialize,
                reserveSetId,
                reserveGroupId,
                contactMethod: this.user.base.reserveNotice
              })
            }
          })
        } else {
          this.modalReserve.open({
            editableUserId: this.user.base.id,
            bibliographies: [
              {
                bibliographyRealId: bibliographyId
              }
            ],
            reservable: true,
            onClosed: () => (this.activeTab = this.tabType.Reserved),
            onChangedReserveInfo: this.initialize,
            contactMethod: this.user.base.reserveNotice
          })
        }
      } catch (error) {
        if (error instanceof AlertMessage) {
          alertStore.setItems(error.alerts)
          this.$modalAlert.open()
        } else if (error instanceof ErrorMessage) {
          modalErrorStore.init(error)
          this.$modalError.open()
        } else {
          console.error(error)
        }
      } finally {
        this.$eventBus.emit(PAGE_LOADING_END)
      }
    } else {
      this.modalReserve.open({
        editableUserId: this.user.base.id,
        bibliographies: [
          {
            bibliographyRealId: bibliographyId
          }
        ],
        reservable: true,
        onClosed: () => (this.activeTab = this.tabType.Reserved),
        onChangedReserveInfo: this.initialize,
        contactMethod: this.user.base.reserveNotice
      })
    }
  }

  async releaseUserMyNumberCard(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await userApi.releaseUserMynumbercard({
        id: this.user.base.id
      })
      await this.initialize()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async updateUserMyNumberCard(ppid: string): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await userApi.updateUserMynumbercard({
        id: this.user.base.id,
        ppid
      })
      await this.initialize()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async releaseUserFelicaId(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await userApi.releaseUserFelicaId({
        id: this.user.base.id
      })
      await this.initialize()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  // ここから資料検索ダイアログ、資料検索結果ダイアログ、資料照会ダイアログの制御記述
  openModalBibliographySearchCondition(isBack: boolean = false) {
    this.$modalBibliographySearchCondition.open({
      isBack,
      onSearch: () => {
        if (this.isHitOneSearchResults) {
          this.openModalBibliographyDetail(
            true,
            this.searchResults[0].prefix,
            this.searchResults[0].bibliographyId,
            this.openModalBibliographySearchResult
          )
          return
        }
        this.openModalBibliographySearchResult()
      },
      onSearchAuthority: () => {
        if (
          modalBibliographySearchStore.authoritySearchType ===
          AuthoritySearchType.ContentAuthor
        ) {
          if (modalBibliographySearchStore.contentItems.length === 1) {
            this.openModalBibliographyDetail(
              true,
              modalBibliographySearchStore.contentItems[0].prefix,
              modalBibliographySearchStore.contentItems[0]?.bibliographyId ?? 0,
              this.openModalBibliographySearchResultContent,
              modalBibliographySearchStore.contentItems[0]
                ?.bibliographyContentId ?? 0
            )
          } else if (modalBibliographySearchStore.authorityItems.length === 1) {
            this.openModalBibliographySearchResultContent()
          } else {
            this.openModalBibliographySearchResultAuthority()
          }
        } else if (this.isHitOneSearchResults) {
          this.openModalBibliographyDetail(
            true,
            this.searchResults[0].prefix,
            this.searchResults[0].bibliographyId,
            this.openModalBibliographySearchResult
          )
        } else if (modalBibliographySearchStore.authorityItems.length === 1) {
          this.openModalBibliographySearchResult()
        } else {
          this.openModalBibliographySearchResultAuthority()
        }
      },
      onSearchContent: () => {
        if (modalBibliographySearchStore.contentItems.length === 1) {
          this.openModalBibliographyDetail(
            true,
            modalBibliographySearchStore.contentItems[0].prefix,
            modalBibliographySearchStore.contentItems[0].bibliographyId,
            this.openModalBibliographySearchResultContent,
            modalBibliographySearchStore.contentItems[0]
              ?.bibliographyContentId ?? 0
          )
        } else {
          this.openModalBibliographySearchResultContent()
        }
      }
    })
  }

  openModalBibliographySearchResult(onBackResult?: () => void) {
    this.$modalBibliographySearchResult.open({
      isSelect: true,
      onBackCondition: () => {
        this.openModalBibliographySearchCondition(true)
      },
      onBackResult,
      onTitle: (bibliographyFullIdWithMarcNo: BibliographyFullIdWithMarcNo) => {
        this.openModalBibliographyDetail(
          true,
          bibliographyFullIdWithMarcNo.prefix,
          bibliographyFullIdWithMarcNo?.id ?? 0,
          () => {
            this.openModalBibliographySearchResult(onBackResult)
          }
        )
      },
      onSelect: (
        bibliographyFullIdsWithMarcNo: BibliographyFullIdWithMarcNo[]
      ) => {
        // 集合書誌が返却されたら対象書誌の照会画面を表示
        if (bibliographyFullIdsWithMarcNo.length > 1) {
          const alert: Alert = AlertFactory.create(AlertCodeILC00023, '書誌')
          alertStore.setItem(alert)
          this.$modalAlert.open()
          return
        }

        modalBibliographySearchResultStore.close()

        if (bibliographyFullIdsWithMarcNo[0].prefix === Prefix.Real) {
          this.processReserve(bibliographyFullIdsWithMarcNo[0].id ?? 0)
        } else if (bibliographyFullIdsWithMarcNo[0].prefix === Prefix.Set) {
          this.openModalBibliographyDetail(
            true,
            bibliographyFullIdsWithMarcNo[0].prefix,
            bibliographyFullIdsWithMarcNo[0].id ?? 0,
            this.openModalBibliographySearchResult
          )
        }
      }
    })
  }

  openModalBibliographySearchResultAuthority() {
    this.$modalBibliographySearchResultAuthority.open({
      onBackCondition: () => {
        this.openModalBibliographySearchCondition(true)
      },
      onSearch: () => {
        if (
          modalBibliographySearchStore.authoritySearchType ===
          AuthoritySearchType.ContentAuthor
        ) {
          if (modalBibliographySearchStore.contentItems.length === 1) {
            this.openModalBibliographyDetail(
              true,
              modalBibliographySearchStore.contentItems[0].prefix,
              modalBibliographySearchStore.contentItems[0]?.bibliographyId ?? 0,
              this.openModalBibliographySearchResultAuthority
            )
          } else {
            this.openModalBibliographySearchResultContent()
          }
        } else if (this.isHitOneSearchResults) {
          this.openModalBibliographyDetail(
            true,
            this.searchResults[0].prefix,
            this.searchResults[0]?.bibliographyId ?? 0,
            this.openModalBibliographySearchResultAuthority
          )
        } else {
          this.openModalBibliographySearchResult(
            this.openModalBibliographySearchResultAuthority
          )
        }
      }
    })
  }

  openModalBibliographySearchResultContent() {
    this.$modalBibliographySearchResultContent.open({
      onBackCondition: () => {
        this.openModalBibliographySearchCondition(true)
      },
      onBackResult: this.openModalBibliographySearchResultAuthority,
      onSelectContent: (
        prefix: Prefix,
        bibliographyRealId: number,
        bibliographyContentId: number
      ) => {
        this.openModalBibliographyDetail(
          true,
          prefix,
          bibliographyRealId,
          this.openModalBibliographySearchResultContent,
          bibliographyContentId
        )
      }
    })
  }

  openModalBibliographyDetail(
    isBibliographySelectProcess: boolean,
    prefix: Prefix,
    bibliographyId: number,
    onBackResult: () => void,
    bibliographyContentId?: number
  ) {
    if (prefix === Prefix.Real) {
      this.openModalBibliographyDetailReal(
        isBibliographySelectProcess,
        bibliographyId,
        modalBibliographySearchStore.contentItems.length > 0
          ? BibliographyDetailRealTabType.Content
          : BibliographyDetailRealTabType.Collection,
        onBackResult,
        bibliographyContentId
      )
      return
    }
    this.openModalBibliographyDetailSet(
      isBibliographySelectProcess,
      bibliographyId,
      BibliographyDetailSetTabType.Volume,
      onBackResult
    )
  }

  openModalBibliographyDetailReal(
    isBibliographySelectProcess: boolean,
    bibliographyRealId: number,
    tabType: BibliographyDetailRealTabType,
    onBackResult: () => void,
    bibliographyContentId?: number
  ) {
    this.$modalBibliographyDetailReal.open({
      isBibliographySelectProcess,
      bibliographyRealId,
      tabType,
      bibliographyContentId,
      onBackCondition: () => {
        this.openModalBibliographySearchCondition(true)
      },
      onBackResult,
      onSelect: (value: SelectBibliographyDetailReal) => {
        modalBibliographyDetailRealStore.close()

        this.processReserve(value.bibliographyId ?? 0)
      },
      onToggleSet: (
        bibliographyId: number,
        tabType: BibliographyDetailSetTabType
      ) => {
        this.openModalBibliographyDetailSet(
          true,
          bibliographyId,
          tabType,
          onBackResult
        )
      }
    })
  }

  openModalBibliographyDetailSet(
    isBibliographySelectProcess: boolean,
    bibliographySetId: number,
    tabType: BibliographyDetailSetTabType,
    onBackResult: () => void
  ) {
    this.$modalBibliographyDetailSet.open({
      isBibliographySelectProcess,
      bibliographySetId,
      tabType,
      onBackCondition: () => {
        this.openModalBibliographySearchCondition(true)
      },
      onBackResult,
      onSelect: (obj: {
        bibliographyFullId: BibliographyFullId
        selectedBibliographyRealId: number
      }) => {
        modalBibliographyDetailSetStore.close()

        this.processReserve(obj.selectedBibliographyRealId)
      },
      onToggleReal: (
        bibliographyId: number,
        tabType: BibliographyDetailRealTabType
      ) => {
        this.openModalBibliographyDetailReal(
          isBibliographySelectProcess,
          bibliographyId,
          tabType,
          onBackResult
        )
      }
    })
  }

  showDifferentNameAlert() {
    alertStore.setItem({
      code: AlertCodeMKPF,
      level: 'INFO',
      message:
        'マイナンバーカードに登録されている名前又は生年月日が利用者情報と異なります。利用者に確認してください。',
      attribute: '',
      index: 0,
      subAttribute: ''
    })
    this.$modalAlert.open({
      onOkClick: this.showMkpfConfirmWindow
    })
  }

  showMkpfConfirmWindow() {
    const width = 1000
    const height = 1000
    const left = (screen.width - width) / 2
    const top = (screen.height - height) / 2

    this.$eventBus.emit(PAGE_LOADING_START)

    const openWindow = window.open(
      `/api/mkpf-confirm`,
      'sub',
      `width=${width}, height=${height}, left=${left}, top=${top}`
    )

    const interval = setInterval(() => {
      if (!openWindow || openWindow.closed) {
        clearInterval(interval)

        const ppid = document.getElementById('ppid_result') as HTMLInputElement
        const confirmResult = document.getElementById(
          'confirm_result'
        ) as HTMLInputElement
        console.log('showMkpfConfirmWindow() ppid', ppid.value)
        console.log(
          'showMkpfConfirmWindow() confirm_result',
          confirmResult.value
        )

        if (confirmResult.value === '1') {
          this.updateUserMyNumberCard(ppid.value)
          return
        }

        this.initialize()
      }
    }, 1000)
  }
}
